var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g, _path50, _g2, _path51, _path52, _path53, _path54, _g3, _path55, _g4, _path56, _g5, _path57, _g6, _path58, _g7, _path59, _path60, _g8, _path61, _g9, _path62, _path63, _path64, _path65, _g10, _path66, _g11, _path67, _g12, _path68, _g13, _path69, _g14, _path70, _g15, _path71, _g16, _path72, _g17, _path73, _path74, _path75, _path76, _g18, _path77, _g19, _path78, _g20, _path79, _g21, _path80, _g22, _path81, _path82, _g23, _path83, _g24, _path84, _path85, _path86, _path87, _g25, _path88, _g26, _path89, _g27, _path90, _g28, _path91, _g29, _path92, _g30, _path93, _g31, _path94, _path95, _path96, _path97, _g32, _path98, _g33, _path99, _g34, _path100, _g35, _path101, _g36, _path102, _path103, _g37, _path104, _g38, _path105, _path106, _path107, _path108, _g39, _path109, _g40, _path110, _g41, _path111, _g42, _path112, _g43, _path113, _g44, _path114, _path115, _path116, _g45, _path117, _g46, _path118, _g47, _path119, _g48, _path120, _path121, _path122, _g49, _path123, _g50, _path124, _path125, _path126, _g51, _path127, _g52, _path128, _path129, _path130, _path131, _g53, _path132, _g54, _path133, _g55, _path134, _g56, _path135, _g57, _path136, _path137, _g58, _path138, _g59, _path139, _path140, _path141, _path142, _g60, _path143, _g61, _path144, _g62, _path145, _g63, _path146, _g64, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculadora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 100,
    viewBox: "0 0 146 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3066_57689)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0976 71.6533L106.007 91.9903L105.935 93.9245L76.0293 73.5876L76.0976 71.6533Z",
    fill: "#D0A175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0977 71.6527L82.1772 70.8086L112.083 91.1455L106.007 91.9896L76.0977 71.6527Z",
    fill: "#E6B382"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.007 91.9896L112.083 91.1455L112.011 93.0798L105.935 93.9239L106.007 91.9896Z",
    fill: "#F1BB88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1826 97.2496L106.151 91.9902L105.983 93.9142L57.0117 99.1736L57.1826 97.2496Z",
    fill: "#F0BA87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1826 97.2498L54.1753 95.1344L103.14 89.875L106.151 91.9904L57.1826 97.2498Z",
    fill: "#E8B483"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0117 99.1741L54.0044 97.0588L54.1753 95.1348L57.1826 97.2501L57.0117 99.1741Z",
    fill: "#D0A276"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4194 77.7256L51.3285 98.066L51.2568 100L21.3511 79.6633L21.4194 77.7256Z",
    fill: "#D0A175"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4194 77.7254L27.499 76.8848L57.4047 97.2217L51.3285 98.0658L21.4194 77.7254Z",
    fill: "#E6B382"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3286 98.0658L57.4047 97.2217L57.333 99.1559L51.2568 100L51.3286 98.0658Z",
    fill: "#F1BB88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7939 93.5996L54.8212 97.6663L51.3115 98.0354L51.2808 93.9687L54.7939 93.5996Z",
    fill: "#F2BC88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3116 98.0352L48.5947 96.2034L48.5674 92.1367L51.2808 93.9685L51.3116 98.0352Z",
    fill: "#CC9E73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2808 93.9684L48.5674 92.1367L52.0805 91.7676L54.7939 93.5993L51.2808 93.9684Z",
    fill: "#E0AE7E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6288 75.1797L27.6596 79.243L24.1465 79.6121L24.1191 75.5488L27.6288 75.1797Z",
    fill: "#F2BC88"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1465 79.6118L21.4297 77.7801L21.4023 73.7168L24.1192 75.5485L24.1465 79.6118Z",
    fill: "#CC9E73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1192 75.5485L21.4023 73.7167L24.9154 73.3477L27.6288 75.1794L24.1192 75.5485Z",
    fill: "#E0AE7E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.021 87.2734L112.049 91.3401L108.536 91.7092L108.508 87.6425L112.021 87.2734Z",
    fill: "#F2BC88"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.536 91.7095L105.819 89.8812L105.792 85.8145L108.508 87.6428L108.536 91.7095Z",
    fill: "#CC9E73"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.508 87.6427L105.792 85.8144L109.305 85.4453L112.021 87.2736L108.508 87.6427Z",
    fill: "#E0AE7E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4076 90.2783L83.435 94.3416L79.9219 94.7107L79.8945 90.6474L83.4076 90.2783Z",
    fill: "#F2BC88"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9219 94.7104L77.2085 92.8787L77.1777 88.8154L79.8946 90.6472L79.9219 94.7104Z",
    fill: "#CC9E73"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8946 90.6471L77.1777 88.8154L80.6908 88.4463L83.4077 90.278L79.8946 90.6471Z",
    fill: "#E0AE7E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0976 66.377L106.007 86.7173L105.935 88.6516L76.0293 68.3146L76.0976 66.377Z",
    fill: "#D0A175"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0977 66.3768L82.1772 65.5361L112.083 85.8731L106.007 86.7172L76.0977 66.3768Z",
    fill: "#E6B382"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.007 86.7171L112.083 85.873L112.011 87.8073L105.935 88.6514L106.007 86.7171Z",
    fill: "#F1BB88"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2632 67.0605L99.1723 87.4009L99.1005 89.3352L69.1948 68.9982L69.2632 67.0605Z",
    fill: "#D0A175"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2632 67.0604L75.3427 66.2197L105.248 86.5567L99.1723 87.4008L69.2632 67.0604Z",
    fill: "#E6B382"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1723 87.4007L105.248 86.5566L105.177 88.4909L99.1006 89.335L99.1723 87.4007Z",
    fill: "#F1BB88"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4282 67.7441L92.3373 88.0845L92.2655 90.0188L62.3599 69.6818L62.4282 67.7441Z",
    fill: "#D0A175"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4282 67.744L68.5078 66.9033L98.4135 87.2403L92.3373 88.0844L62.4282 67.744Z",
    fill: "#E6B382"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3374 88.0843L98.4135 87.2402L98.3418 89.1745L92.2656 90.0186L92.3374 88.0843Z",
    fill: "#F1BB88"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5932 68.4277L85.5023 88.7681L85.4306 90.7024L55.5249 70.3654L55.5932 68.4277Z",
    fill: "#D0A175"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5933 68.4276L61.6728 67.5869L91.5785 87.9239L85.5024 88.768L55.5933 68.4276Z",
    fill: "#E6B382"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5024 88.7679L91.5786 87.9238L91.5068 89.8581L85.4307 90.7022L85.5024 88.7679Z",
    fill: "#F1BB88"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7588 69.1113L78.6679 89.4517L78.5961 91.386L48.6904 71.049L48.7588 69.1113Z",
    fill: "#D0A175"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7588 69.1112L54.8383 68.2705L84.744 88.6075L78.6679 89.4516L48.7588 69.1112Z",
    fill: "#E6B382"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78.668 89.4515L84.7441 88.6074L84.6723 90.5417L78.5962 91.3858L78.668 89.4515Z",
    fill: "#F1BB88"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9238 69.7939L71.8329 90.1343L71.7611 92.0686L41.8555 71.7316L41.9238 69.7939Z",
    fill: "#D0A175"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9238 69.7938L48.0034 68.9531L77.9091 89.2901L71.8329 90.1342L41.9238 69.7938Z",
    fill: "#E6B382"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M71.833 90.1341L77.9091 89.29L77.8374 91.2243L71.7612 92.0684L71.833 90.1341Z",
    fill: "#F1BB88"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0889 70.4775L64.998 90.8179L64.9262 92.7522L35.0205 72.4152L35.0889 70.4775Z",
    fill: "#D0A175"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0889 70.4774L41.1684 69.6367L71.0741 89.9737L64.998 90.8178L35.0889 70.4774Z",
    fill: "#E6B382"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M64.998 90.8177L71.0742 89.9736L71.0024 91.9079L64.9263 92.752L64.998 90.8177Z",
    fill: "#F1BB88"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2544 71.1611L58.1635 91.5015L58.0917 93.4358L28.186 73.0988L28.2544 71.1611Z",
    fill: "#D0A175"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2544 71.161L34.334 70.3203L64.2396 90.6573L58.1635 91.5014L28.2544 71.161Z",
    fill: "#E6B382"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1636 91.5013L64.2397 90.6572L64.1679 92.5915L58.0918 93.4356L58.1636 91.5013Z",
    fill: "#F1BB88"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4194 71.8447L51.3285 92.1851L51.2568 94.1194L21.3511 73.7824L21.4194 71.8447Z",
    fill: "#D0A175"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4194 71.8446L27.499 71.0039L57.4047 91.3409L51.3285 92.185L21.4194 71.8446Z",
    fill: "#E6B382"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3286 92.1849L57.4047 91.3408L57.333 93.2751L51.2568 94.1192L51.3286 92.1849Z",
    fill: "#F1BB88"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 34,
    width: 15,
    height: 11
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4365 34.5882L96.7383 44.2287C96.6597 44.1741 96.5606 44.1501 96.4512 44.1604L82.1494 34.5199C82.2554 34.5096 82.3579 34.5336 82.4365 34.5882Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4547 44.1572L82.1528 34.5167C82.2314 34.5099 82.3066 34.5201 82.3715 34.5475L96.6734 44.1879C96.6084 44.1606 96.5333 44.1469 96.4547 44.1572Z",
    fill: "#BC485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6734 44.1913L82.3716 34.5508C82.3955 34.561 82.4194 34.5747 82.4399 34.5884L96.7418 44.2289C96.7212 44.2152 96.6973 44.2015 96.6734 44.1913Z",
    fill: "#B9475C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 68,
    width: 16,
    height: 11
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0616 78.4578L52.7597 68.8173C52.6435 68.7387 52.5718 68.6054 52.5684 68.4482L66.8702 78.0887C66.8702 78.2494 66.9454 78.3826 67.0616 78.4578Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0616 78.4578L52.7597 68.8173C52.6435 68.7387 52.5718 68.6054 52.5684 68.4482L66.8702 78.0887C66.8702 78.2494 66.9454 78.3826 67.0616 78.4578Z",
    fill: "#A84153"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1304 47.2391L52.8252 37.602L82.1499 34.5195L96.4552 44.1566L67.1304 47.2391Z",
    fill: "#C14A5F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8706 78.0847L52.5688 68.4476L52.3569 38.1387L66.6588 47.7792L66.8706 78.0847Z",
    fill: "#A54052"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M96.455 44.1569C96.7182 44.1295 96.93 44.3243 96.9334 44.5977L97.1453 74.9032C97.1453 75.1732 96.9369 75.4158 96.6737 75.4432L67.349 78.5257C67.0859 78.553 66.874 78.3582 66.8706 78.0848L66.6587 47.7793C66.6587 47.5093 66.8671 47.2667 67.1303 47.2393L96.455 44.1569Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 37,
    width: 16,
    height: 11
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6588 47.7791L52.3569 38.1386C52.3569 37.8686 52.5654 37.626 52.8285 37.5986L67.1304 47.2391C66.8672 47.2665 66.6588 47.5057 66.6588 47.7791Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6588 47.7786L52.3569 38.1381C52.3569 38.0425 52.3843 37.9502 52.4287 37.8682L66.7305 47.5087C66.6861 47.5907 66.6588 47.6829 66.6588 47.7786Z",
    fill: "#A84153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7305 47.5091L52.4287 37.8686C52.4424 37.8447 52.4595 37.8208 52.4766 37.7969L66.7784 47.4374C66.7613 47.4579 66.7442 47.4818 66.7305 47.5091Z",
    fill: "#AB4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7784 47.4374L52.4766 37.7969C52.4902 37.7798 52.5073 37.7593 52.5244 37.7422L66.8262 47.3827C66.8262 47.3827 66.7921 47.4169 66.7784 47.4374Z",
    fill: "#AE4356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8262 47.3861L52.5244 37.7456C52.5244 37.7456 52.5586 37.7148 52.5757 37.7012L66.8775 47.3417C66.8604 47.3553 66.8433 47.369 66.8262 47.3861Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8775 47.3412L52.5757 37.7007C52.5928 37.687 52.6133 37.6733 52.6304 37.6631L66.9322 47.3036C66.9117 47.3138 66.8946 47.3275 66.8775 47.3412Z",
    fill: "#B34559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9322 47.3041L52.6304 37.6636C52.6509 37.6499 52.6748 37.6396 52.6953 37.6328L66.9971 47.2733C66.9732 47.2836 66.9527 47.2938 66.9322 47.3041Z",
    fill: "#B6465A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9971 47.2733L52.6953 37.6328C52.7227 37.6226 52.7534 37.6123 52.7842 37.6055L67.086 47.246C67.0552 47.2528 67.0245 47.2596 66.9971 47.2733Z",
    fill: "#B9475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.086 47.246L52.7842 37.6055C52.7842 37.6055 52.8115 37.6021 52.8252 37.5986L67.127 47.2391C67.127 47.2391 67.0997 47.2425 67.086 47.246Z",
    fill: "#BC485D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 60,
    width: 11,
    height: 16
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6172 69.2031L55.4736 60.0889L65.3157 66.2368L65.4593 75.3544L55.6172 69.2031Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9243 72.1108L60.7944 63.8271L65.0935 66.5131L65.2233 74.7969L60.9243 72.1108ZM65.3156 66.2363L65.2028 66.1646L60.6714 63.3315L60.5586 63.2598V63.4716L60.6987 72.1655V72.374L60.8149 72.4457L65.3464 75.2788L65.4591 75.3505V75.1421L65.319 66.4482V66.2363",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9577 65.8438H62.9509L62.9201 65.8779L62.9133 66.558L62.944 66.5751C62.6057 66.37 62.1683 66.1411 61.8163 66.2846C61.724 66.3188 61.6454 66.3837 61.5668 66.4691C61.4917 66.5546 61.4233 66.6571 61.3686 66.787C61.3139 66.9134 61.2695 67.0603 61.2422 67.2278C61.2285 67.3167 61.2183 67.4021 61.2114 67.4944C61.2046 67.59 61.2046 67.7336 61.2046 67.8361C61.4131 67.8156 61.5361 67.8122 61.6557 67.8874C61.7753 67.9625 61.8949 68.1129 62.1034 68.3965C62.2947 68.3521 62.4246 68.3521 62.551 68.4307C62.6638 68.5025 62.78 68.6392 62.9372 68.8613L62.944 69.2714L62.9782 69.2919L63.0261 72.2582C63.0295 72.5316 63.1593 72.8358 63.3063 72.928C63.4532 73.0203 63.5763 72.8733 63.5729 72.6L63.566 72.0942L63.5284 72.0053L63.4942 72.0498L63.5011 72.5555C63.5011 72.7572 63.4157 72.8631 63.3063 72.7947C63.1969 72.7264 63.1012 72.5077 63.1012 72.3061L63.0534 69.3398L63.0842 69.3603L63.0773 68.9502C63.2414 68.9228 63.361 68.9262 63.4806 69.0014C63.607 69.08 63.7335 69.2406 63.9112 69.5243C64.082 69.4628 64.2119 69.4594 64.3486 69.5448C64.4853 69.6302 64.6254 69.8011 64.8134 70.0847C64.8031 69.4457 64.5878 68.5572 64.2597 67.9318C63.9317 67.3201 63.4874 66.91 62.9987 66.599L63.0295 66.6195L62.9987 65.9155L62.968 65.8369",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8393 68.9331L55.7094 60.6493L60.0085 63.3354L60.1384 71.6192L55.8393 68.9331ZM60.2341 63.062L60.1179 62.9902L55.5898 60.1606L55.4736 60.0889V60.3007L55.6137 68.9946V69.2031L55.7334 69.2748L60.2614 72.1045L60.3776 72.1762V71.9678L60.2375 63.2739V63.062",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5678 69.8185L56.3691 67.8193L56.3794 68.6293L59.5781 70.6284L59.5678 69.8185Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.162 62.7305L56.6733 63.9197L56.9296 64.0803L56.9843 67.7575L57.4969 68.0787L57.4423 64.4016L57.6986 64.5622L57.162 62.7305Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5971 63.626L58.1084 64.8187L58.3647 64.9759L58.4228 68.6564L58.9354 68.9776L58.8773 65.2971L59.1336 65.4577L58.5971 63.626Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 64,
    width: 9,
    height: 11
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M86.251 74.4929L86.1826 64.9823L94.9004 64.0664L94.9653 73.577L86.251 74.4929Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2991 66.6844C88.995 66.7151 88.6942 66.886 88.5473 67.173L88.0415 68.1368L89.5315 68.8681L90.4576 67.091L89.7878 66.763C89.6409 66.6912 89.47 66.6639 89.2991 66.6844Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1277 66.2471C90.6116 66.3017 89.9931 66.4282 89.5522 66.4965C90.0922 66.6572 90.3485 66.7938 90.5159 66.91C90.9124 67.1903 90.8748 67.344 91.114 67.8772C90.8919 68.0309 90.6663 68.1847 90.4442 68.3419C91.0286 68.3112 91.6095 68.2838 92.1939 68.2531C92.5015 67.696 92.8159 67.1288 93.1268 66.5717C92.8979 66.6913 92.6723 66.8178 92.4468 66.9374C92.4024 66.8724 92.3648 66.8075 92.3272 66.7392C92.2827 66.6742 92.2383 66.6093 92.1973 66.5478C91.9752 66.2881 91.7975 66.2197 91.5856 66.2197C91.4489 66.2197 91.2917 66.23 91.1242 66.2471",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6645 74.0145L86.603 65.3684L94.4801 64.5414L94.5416 73.1875L86.6645 74.0145ZM94.9004 64.0664L94.6885 64.0869L86.3945 64.9583L86.1826 64.9789V65.1941L86.2475 74.2742V74.4895L86.4594 74.469L94.7535 73.5975L94.9653 73.577V73.3617L94.9004 64.2817V64.0664Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0652 67.8291L91.6128 68.909L92.6038 70.4537L93.2566 69.9684C93.6564 69.6745 93.8546 69.0525 93.6017 68.6698L93.0618 67.8291",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5477 69.9482C91.247 70.495 90.9462 71.0418 90.6455 71.5852C90.9497 72.0909 91.2504 72.5967 91.5477 73.1025C91.575 72.8462 91.599 72.5933 91.6195 72.3336C91.6981 72.3267 91.7801 72.3131 91.8553 72.3028C91.9339 72.2857 92.0125 72.2721 92.0877 72.2618C92.4328 72.1593 92.5934 72.026 92.7165 71.8278C93.0343 71.3152 93.3692 70.4198 93.6221 69.8525C93.1812 70.2831 92.9215 70.4677 92.7301 70.5702C92.5217 70.683 92.385 70.7274 92.2449 70.7445C92.0706 70.7616 91.8929 70.7376 91.5716 70.7445C91.5614 70.4779 91.5545 70.2114 91.5477 69.9482Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4995 70.976L88.5064 71.7757C88.5064 72.261 88.8994 72.7087 89.3675 72.6608L90.3825 72.5583L90.3757 70.7881L88.5029 70.976",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9585 68.8642C87.1533 68.9975 87.3481 69.1342 87.5463 69.2675C87.5053 69.3427 87.4677 69.4144 87.4301 69.4896C87.3959 69.5682 87.3583 69.64 87.3276 69.7186C87.1977 70.0672 87.2114 70.2688 87.3037 70.4636C87.5326 70.9728 88.0657 71.6631 88.3801 72.1415C88.2913 71.5606 88.2981 71.2496 88.3255 71.0309C88.3972 70.508 88.5442 70.4465 88.8927 69.927C89.1149 70.0398 89.337 70.1458 89.5591 70.262C89.2926 69.7493 89.0226 69.2402 88.756 68.7344C88.1546 68.7754 87.56 68.8164 86.9585 68.8608",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 35,
    width: 19,
    height: 11
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4137 45.822L66.2417 36.144L70.5715 35.6895L84.7435 45.3675L80.4137 45.822Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5715 35.6895L66.2417 36.144L80.4137 45.822L84.7435 45.3675L70.5715 35.6895Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 45,
    width: 5,
    height: 6
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4546 50.1686L80.4272 45.8012L84.7537 45.3467L84.7844 49.7141L80.4546 50.1686Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7537 45.3467L80.4272 45.8012L80.4546 50.1686L84.7844 49.7141L84.7537 45.3467Z",
    fill: "#843D47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2523 34.5575L53.0131 37.5341C52.9003 37.5443 52.8661 37.6913 52.9584 37.7528L66.9526 47.1814C66.9766 47.1985 67.0039 47.2053 67.0312 47.2019L96.2705 44.2253C96.3833 44.2151 96.4175 44.0681 96.3252 44.0066L82.3309 34.578C82.307 34.5609 82.2797 34.5541 82.2523 34.5575Z",
    fill: "#192227"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 2,
    width: 15,
    height: 11
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4365 2.92906L96.7383 12.5696C96.6597 12.5149 96.5606 12.491 96.4512 12.5012L82.1494 2.86072C82.2554 2.85046 82.3579 2.87439 82.4365 2.92906Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4547 12.498L82.1528 2.85752C82.2314 2.85068 82.3066 2.86094 82.3715 2.88828L96.6734 12.5288C96.6084 12.5014 96.5333 12.4878 96.4547 12.498Z",
    fill: "#BC485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6734 12.5321L82.3716 2.8916C82.3955 2.90185 82.4194 2.91552 82.4399 2.92919L96.7418 12.5697C96.7212 12.556 96.6973 12.5423 96.6734 12.5321Z",
    fill: "#B9475C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 36,
    width: 16,
    height: 11
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M67.062 46.7986L52.7602 37.1581C52.644 37.0795 52.5723 36.9463 52.5688 36.7891L66.8707 46.4296C66.8707 46.5902 66.9459 46.7234 67.062 46.7986Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.062 46.7986L52.7602 37.1581C52.644 37.0795 52.5723 36.9463 52.5688 36.7891L66.8707 46.4296C66.8707 46.5902 66.9459 46.7234 67.062 46.7986Z",
    fill: "#A84153"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1304 15.5799L52.8252 5.94285L82.1499 2.86035L96.4552 12.4974L67.1304 15.5799Z",
    fill: "#C14A5F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8706 46.4255L52.5688 36.7884L52.3569 6.47949L66.6588 16.12L66.8706 46.4255Z",
    fill: "#A54052"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M96.455 12.4977C96.7182 12.4703 96.93 12.6651 96.9334 12.9385L97.1453 43.244C97.1453 43.514 96.9369 43.7566 96.6737 43.784L67.349 46.8665C67.0859 46.8938 66.874 46.699 66.8706 46.4256L66.6587 16.1201C66.6587 15.8501 66.8671 15.6075 67.1303 15.5802L96.455 12.4977Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 5,
    width: 16,
    height: 12
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6588 16.1199L52.3569 6.4794C52.3569 6.20943 52.5654 5.96679 52.8285 5.93945L67.1304 15.5799C66.8672 15.6073 66.6588 15.8465 66.6588 16.1199Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6588 16.1194L52.3569 6.47896C52.3569 6.38327 52.3843 6.291 52.4287 6.20898L66.7305 15.8495C66.6861 15.9315 66.6588 16.0238 66.6588 16.1194Z",
    fill: "#A84153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7305 15.85L52.4287 6.20946C52.4424 6.18554 52.4595 6.16162 52.4766 6.1377L66.7784 15.7782C66.7613 15.7987 66.7442 15.8226 66.7305 15.85Z",
    fill: "#AB4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7784 15.7782L52.4766 6.13769C52.4902 6.1206 52.5073 6.10009 52.5244 6.08301L66.8262 15.7235C66.8262 15.7235 66.7921 15.7577 66.7784 15.7782Z",
    fill: "#AE4356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8262 15.7269L52.5244 6.08642C52.5244 6.08642 52.5586 6.05566 52.5757 6.04199L66.8775 15.6825C66.8604 15.6962 66.8433 15.7098 66.8262 15.7269Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8775 15.682L52.5757 6.0415C52.5928 6.02783 52.6133 6.01416 52.6304 6.00391L66.9322 15.6444C66.9117 15.6546 66.8946 15.6683 66.8775 15.682Z",
    fill: "#B34559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9322 15.6449L52.6304 6.00439C52.6509 5.99072 52.6748 5.98047 52.6953 5.97363L66.9971 15.6141C66.9732 15.6244 66.9527 15.6346 66.9322 15.6449Z",
    fill: "#B6465A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9971 15.6141L52.6953 5.97363C52.7227 5.96338 52.7534 5.95312 52.7842 5.94629L67.086 15.5868C67.0552 15.5936 67.0245 15.6004 66.9971 15.6141Z",
    fill: "#B9475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.086 15.5868L52.7842 5.94629C52.7842 5.94629 52.8115 5.94287 52.8252 5.93945L67.127 15.5799C67.127 15.5799 67.0997 15.5834 67.086 15.5868Z",
    fill: "#BC485D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 28,
    width: 11,
    height: 16
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6172 37.5439L55.4736 28.4297L65.3157 34.5776L65.4593 43.6952L55.6172 37.5439Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9243 40.4482L60.7944 32.1645L65.0935 34.8505L65.2233 43.1343L60.9243 40.4482ZM65.3156 34.5771L65.2028 34.5054L60.6714 31.6724L60.5586 31.6006V31.8125L60.6987 40.5063V40.7148L60.8149 40.7866L65.3464 43.6196L65.4591 43.6914V43.4829L65.319 34.789V34.5771",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9577 34.1816H62.9509L62.9201 34.2158L62.9133 34.8959L62.944 34.913C62.6057 34.7079 62.1683 34.479 61.8163 34.6225C61.724 34.6567 61.6454 34.7216 61.5668 34.807C61.4917 34.8925 61.4233 34.995 61.3686 35.1248C61.3139 35.2513 61.2695 35.3982 61.2422 35.5657C61.2285 35.6545 61.2183 35.74 61.2114 35.8322C61.2046 35.9279 61.2046 36.0715 61.2046 36.174C61.4131 36.1535 61.5361 36.1501 61.6557 36.2252C61.7753 36.3004 61.8949 36.4508 62.1034 36.7344C62.2947 36.69 62.4246 36.69 62.551 36.7686C62.6638 36.8404 62.78 36.9771 62.9372 37.1992L62.944 37.6093L62.9782 37.6298L63.0261 40.5961C63.0295 40.8695 63.1593 41.1736 63.3063 41.2659C63.4532 41.3582 63.5763 41.2112 63.5729 40.9378L63.566 40.4321L63.5284 40.3432L63.4942 40.3876L63.5011 40.8934C63.5011 41.095 63.4157 41.201 63.3063 41.1326C63.1969 41.0643 63.1012 40.8456 63.1012 40.6439L63.0534 37.6776L63.0842 37.6981L63.0773 37.2881C63.2414 37.2607 63.361 37.2641 63.4806 37.3393C63.607 37.4179 63.7335 37.5785 63.9112 37.8622C64.082 37.8007 64.2119 37.7972 64.3486 37.8827C64.4853 37.9681 64.6254 38.139 64.8134 38.4226C64.8031 37.7836 64.5878 36.8951 64.2597 36.2697C63.9317 35.658 63.4874 35.2479 62.9987 34.9369L63.0295 34.9574L62.9987 34.2534L62.968 34.1748",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8393 37.2739L55.7094 28.9901L60.0085 31.6762L60.1384 39.96L55.8393 37.2739ZM60.2341 31.4028L60.1179 31.3311L55.5898 28.5015L55.4736 28.4297V28.6416L55.6137 37.3354V37.5439L55.7334 37.6157L60.2614 40.4453L60.3776 40.517V40.3086L60.2375 31.6147V31.4028",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5678 38.1593L56.3691 36.1602L56.3794 36.9701L59.5781 38.9693L59.5678 38.1593Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.162 31.0713L56.6733 32.2605L56.9296 32.4212L56.9843 36.0983L57.4969 36.4195L57.4423 32.7424L57.6986 32.8996L57.162 31.0713Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5971 31.9668L58.1084 33.1595L58.3647 33.3167L58.4228 36.9972L58.9354 37.3184L58.8773 33.6379L59.1336 33.7985L58.5971 31.9668Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 32,
    width: 9,
    height: 11
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M86.251 42.8337L86.1826 33.3231L94.9004 32.4072L94.9653 41.9144L86.251 42.8337Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2991 35.0213C88.995 35.052 88.6942 35.2229 88.5473 35.51L88.0415 36.4737L89.5315 37.205L90.4576 35.4279L89.7878 35.0999C89.6409 35.0281 89.47 35.0008 89.2991 35.0213Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1277 34.5879C90.6116 34.6426 89.9931 34.769 89.5522 34.8374C90.0922 34.998 90.3485 35.1347 90.5159 35.2509C90.9124 35.5311 90.8748 35.6849 91.114 36.218C90.8919 36.3718 90.6663 36.5256 90.4442 36.6828C91.0286 36.652 91.6095 36.6247 92.1939 36.5939C92.5015 36.0369 92.8159 35.4696 93.1268 34.9125C92.8979 35.0322 92.6723 35.1586 92.4468 35.2782C92.4024 35.2133 92.3648 35.1483 92.3272 35.08C92.2827 35.0151 92.2383 34.9501 92.1973 34.8886C91.9752 34.6289 91.7975 34.5605 91.5856 34.5605C91.4489 34.5605 91.2917 34.5708 91.1242 34.5879",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6645 42.3553L86.603 33.7093L94.4801 32.8822L94.5416 41.5283L86.6645 42.3553ZM94.9004 32.4072L94.6885 32.4277L86.3945 33.2992L86.1826 33.3197V33.535L86.2475 42.615V42.8303L86.4594 42.8098L94.7535 41.9384L94.9653 41.9179V41.7026L94.9004 32.6225V32.4072Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0652 36.1699L91.6128 37.2498L92.6038 38.7945L93.2566 38.3092C93.6564 38.0153 93.8546 37.3934 93.6017 37.0106L93.0618 36.1699",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5477 38.289C91.247 38.8358 90.9462 39.3826 90.6455 39.926C90.9497 40.4318 91.2504 40.9375 91.5477 41.4433C91.575 41.187 91.599 40.9341 91.6195 40.6744C91.6981 40.6676 91.7801 40.6539 91.8553 40.6436C91.9339 40.6265 92.0125 40.6129 92.0877 40.6026C92.4328 40.5001 92.5934 40.3668 92.7165 40.1686C93.0343 39.656 93.3692 38.7606 93.6221 38.1934C93.1812 38.624 92.9215 38.8085 92.7301 38.911C92.5217 39.0238 92.385 39.0682 92.2449 39.0853C92.0706 39.1024 91.8929 39.0785 91.5716 39.0853C91.5614 38.8187 91.5545 38.5522 91.5477 38.289Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4995 39.3169L88.5064 40.1165C88.5064 40.6018 88.8994 41.0495 89.3675 41.0016L90.3825 40.8991L90.3757 39.1289L88.5029 39.3169",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9585 37.2051C87.1533 37.3383 87.3481 37.475 87.5463 37.6083C87.5053 37.6835 87.4677 37.7553 87.4301 37.8304C87.3959 37.909 87.3583 37.9808 87.3276 38.0594C87.1977 38.408 87.2114 38.6096 87.3037 38.8044C87.5326 39.3136 88.0657 40.0039 88.3801 40.4823C88.2913 39.9014 88.2981 39.5904 88.3255 39.3717C88.3972 38.8488 88.5442 38.7873 88.8927 38.2679C89.1149 38.3806 89.337 38.4866 89.5591 38.6028C89.2926 38.0902 89.0226 37.581 88.756 37.0752C88.1546 37.1162 87.56 37.1572 86.9585 37.2016",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 4,
    width: 19,
    height: 11
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4137 14.1619L66.2417 4.48381L70.5715 4.0293L84.7435 13.7074L80.4137 14.1619Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5715 4.0293L66.2417 4.48381L80.4137 14.1619L84.7435 13.7074L70.5715 4.0293Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 13,
    width: 5,
    height: 6
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4546 18.5095L80.4272 14.142L84.7537 13.6875L84.7844 18.0549L80.4546 18.5095Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7537 13.6875L80.4272 14.142L80.4546 18.5095L84.7844 18.0549L84.7537 13.6875Z",
    fill: "#843D47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 12,
    width: 31,
    height: 67
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5288 78.8679L66.6416 15.5503L96.9437 12.6318L96.8309 75.9529L66.5288 78.8679Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5951 12.6664L66.9867 15.5165C66.7954 15.5336 66.6416 15.7113 66.6416 15.9061L66.5322 78.5129C66.5322 78.7077 66.686 78.8546 66.8774 78.8375L96.4858 75.9874C96.6771 75.9703 96.8343 75.7926 96.8343 75.5978L96.9437 12.991C96.9437 12.7963 96.7899 12.6493 96.5951 12.6664Z",
    fill: "#192227"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 44,
    width: 15,
    height: 11
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5141 44.639L111.816 54.2795C111.737 54.2248 111.638 54.2009 111.529 54.2112L97.2271 44.5707C97.333 44.5604 97.4355 44.5843 97.5141 44.639Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.529 54.208L97.2271 44.5675C97.3057 44.5606 97.3808 44.5709 97.4458 44.5982L111.748 54.2387C111.683 54.2114 111.607 54.1977 111.529 54.208Z",
    fill: "#BC485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.748 54.2421L97.4458 44.6016C97.4697 44.6118 97.4936 44.6255 97.5142 44.6392L111.816 54.2796C111.795 54.266 111.772 54.2523 111.748 54.2421Z",
    fill: "#B9475C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 78,
    width: 16,
    height: 11
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1358 88.5086L67.834 78.8681C67.7178 78.7895 67.646 78.6562 67.6426 78.499L81.9444 88.1395C81.9444 88.3001 82.0196 88.4334 82.1358 88.5086Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.1358 88.5086L67.834 78.8681C67.7178 78.7895 67.646 78.6562 67.6426 78.499L81.9444 88.1395C81.9444 88.3001 82.0196 88.4334 82.1358 88.5086Z",
    fill: "#A84153"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2042 57.2899L67.9023 47.6528L97.2271 44.5703L111.529 54.2074L82.2042 57.2899Z",
    fill: "#C14A5F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9444 88.1355L67.6425 78.4984L67.4307 48.1895L81.7359 57.8299L81.9444 88.1355Z",
    fill: "#A54052"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M111.529 54.2076C111.792 54.1803 112.004 54.3751 112.007 54.6485L112.219 84.954C112.219 85.224 112.011 85.4666 111.747 85.4939L82.4227 88.5764C82.1596 88.6038 81.9477 88.409 81.9443 88.1356L81.7324 57.8301C81.7324 57.5601 81.9409 57.3175 82.204 57.2901L111.529 54.2076Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 47,
    width: 16,
    height: 11
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7359 57.8299L67.4341 48.1894C67.4341 47.9194 67.6425 47.6768 67.9057 47.6494L82.2075 57.2899C81.9444 57.3172 81.7359 57.5565 81.7359 57.8299Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7359 57.8294L67.4341 48.1889C67.4341 48.0932 67.4614 48.001 67.5058 47.9189L81.8077 57.5594C81.7633 57.6414 81.7359 57.7337 81.7359 57.8294Z",
    fill: "#A84153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8077 57.5599L67.5059 47.9194C67.5195 47.8955 67.5366 47.8716 67.5537 47.8477L81.8555 57.4881C81.8384 57.5087 81.8214 57.5326 81.8077 57.5599Z",
    fill: "#AB4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8555 57.4881L67.5537 47.8476C67.5674 47.8306 67.5845 47.8101 67.6016 47.793L81.9034 57.4335C81.9034 57.4335 81.8692 57.4676 81.8555 57.4881Z",
    fill: "#AE4356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9034 57.4369L67.6016 47.7964C67.6016 47.7964 67.6357 47.7656 67.6528 47.752L81.9546 57.3924C81.9376 57.4061 81.9205 57.4198 81.9034 57.4369Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9512 57.392L67.6494 47.7515C67.6665 47.7378 67.687 47.7241 67.7041 47.7139L82.0059 57.3544C81.9854 57.3646 81.9683 57.3783 81.9512 57.392Z",
    fill: "#B34559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0093 57.3548L67.7075 47.7143C67.728 47.7007 67.7519 47.6904 67.7725 47.6836L82.0743 57.3241C82.0504 57.3343 82.0299 57.3446 82.0093 57.3548Z",
    fill: "#B6465A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0743 57.3241L67.7725 47.6836C67.7998 47.6733 67.8306 47.6631 67.8613 47.6562L82.1631 57.2967C82.1324 57.3036 82.1016 57.3104 82.0743 57.3241Z",
    fill: "#B9475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1632 57.2967L67.8613 47.6563C67.8613 47.6563 67.8887 47.6528 67.9023 47.6494L82.2042 57.2899C82.2042 57.2899 82.1768 57.2933 82.1632 57.2967Z",
    fill: "#BC485D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 70,
    width: 11,
    height: 16
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6909 79.2539L70.5508 70.1396L80.3929 76.2875L80.533 85.4052L70.6909 79.2539Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.998 82.1582L75.8681 73.8744L80.1672 76.5605L80.2971 84.8443L75.998 82.1582ZM80.3928 76.2871L80.28 76.2153L75.7485 73.3823L75.6357 73.3105V73.5224L75.7759 82.2163V82.4248L75.892 82.4965L80.4235 85.3295L80.5363 85.4013V85.1928L80.3962 76.499V76.2871",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0349 75.8945H78.028L77.9973 75.9287L77.9904 76.6088L78.0212 76.6259C77.6829 76.4208 77.2454 76.1918 76.8935 76.3354C76.8012 76.3695 76.7226 76.4345 76.644 76.5199C76.5688 76.6054 76.5005 76.7079 76.4458 76.8377C76.3911 76.9642 76.3467 77.1111 76.3193 77.2786C76.3057 77.3674 76.2954 77.4529 76.2886 77.5451C76.2817 77.6408 76.2817 77.7844 76.2817 77.8869C76.4902 77.8664 76.6132 77.863 76.7328 77.9381C76.8524 78.0133 76.9721 78.1637 77.1805 78.4473C77.3719 78.4029 77.5018 78.4029 77.6282 78.4815C77.741 78.5533 77.8572 78.69 78.0144 78.9121L78.0212 79.3222L78.0554 79.3427L78.1032 82.309C78.1066 82.5824 78.2365 82.8865 78.3834 82.9788C78.5304 83.0711 78.6534 82.9241 78.65 82.6507L78.6432 82.145L78.6056 82.0561L78.5714 82.1005L78.5782 82.6063C78.5782 82.8079 78.4928 82.9139 78.3834 82.8455C78.2741 82.7772 78.1784 82.5585 78.1784 82.3568L78.1306 79.3905L78.1613 79.411L78.1545 79.0009C78.3185 78.9736 78.4381 78.977 78.5577 79.0522C78.6842 79.1308 78.8106 79.2914 78.9883 79.5751C79.1592 79.5136 79.2891 79.5101 79.4258 79.5956C79.5624 79.681 79.7026 79.8519 79.8905 80.1355C79.8803 79.4965 79.665 78.6079 79.3369 77.9826C79.0088 77.3708 78.5646 76.9608 78.0759 76.6498L78.1066 76.6703L78.0759 75.9663L78.0451 75.8877",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9164 78.9839L70.7866 70.7001L75.0857 73.3862L75.2155 81.67L70.9164 78.9839ZM75.3078 73.1128L75.1916 73.041L70.6636 70.2114L70.5474 70.1396V70.3515L70.6875 79.0454V79.2539L70.8071 79.3256L75.3351 82.1552L75.4513 82.227V82.0185L75.3112 73.3247V73.1128",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6416 79.8693L71.4429 77.8701L71.4565 78.68L74.6552 80.6792L74.6416 79.8693Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2358 72.7812L71.7471 73.9705L72.0034 74.1311L72.0615 77.8082L72.5741 78.1295L72.516 74.4524L72.7723 74.613L72.2358 72.7812Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6708 73.6768L73.1821 74.8694L73.4384 75.0266L73.4965 78.7072L74.0091 79.0284L73.951 75.3479L74.2073 75.5085L73.6708 73.6768Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 74,
    width: 10,
    height: 11
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M101.324 84.5437L101.259 75.033L109.974 74.1172L110.039 83.6278L101.324 84.5437Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.376 76.7351C104.072 76.7659 103.771 76.9368 103.624 77.2238L103.118 78.1875L104.608 78.9189L105.534 77.1418L104.864 76.8137C104.718 76.742 104.547 76.7146 104.376 76.7351Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.201 76.2978C105.685 76.3525 105.066 76.479 104.625 76.5473C105.165 76.7079 105.422 76.8446 105.589 76.9608C105.986 77.2411 105.948 77.3948 106.187 77.9279C105.965 78.0817 105.74 78.2355 105.517 78.3927C106.102 78.362 106.683 78.3346 107.267 78.3039C107.575 77.7468 107.889 77.1795 108.2 76.6225C107.971 76.7421 107.746 76.8686 107.52 76.9882C107.476 76.9232 107.438 76.8583 107.4 76.79C107.356 76.725 107.312 76.6601 107.271 76.5986C107.048 76.3389 106.871 76.2705 106.659 76.2705C106.522 76.2705 106.365 76.2808 106.197 76.2978",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.741 84.0652L101.68 75.4192L109.557 74.5922L109.618 83.2382L101.741 84.0652ZM109.974 74.1172L109.762 74.1377L101.468 75.0091L101.256 75.0296V75.2449L101.321 84.325V84.5403L101.533 84.5198L109.827 83.6483L110.039 83.6278V83.4125L109.974 74.3325V74.1172Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.138 77.8799L106.686 78.9598L107.677 80.5044L108.33 80.0192C108.73 79.7253 108.928 79.1033 108.675 78.7206L108.135 77.8799",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.621 79.999C106.32 80.5458 106.019 81.0926 105.719 81.6359C106.023 82.1417 106.324 82.6475 106.621 83.1533C106.648 82.897 106.672 82.6441 106.693 82.3844C106.771 82.3775 106.853 82.3638 106.929 82.3536C107.007 82.3365 107.086 82.3228 107.161 82.3126C107.506 82.2101 107.667 82.0768 107.79 81.8786C108.108 81.366 108.442 80.4706 108.695 79.9033C108.254 80.3339 107.995 80.5185 107.803 80.621C107.595 80.7338 107.458 80.7782 107.318 80.7953C107.144 80.8123 106.966 80.7884 106.645 80.7953C106.635 80.5287 106.628 80.2621 106.621 79.999Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.576 81.0268L103.583 81.8265C103.583 82.3118 103.976 82.7594 104.444 82.7116L105.459 82.6091L105.452 80.8389L103.58 81.0268",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.035 78.915C102.23 79.0483 102.425 79.185 102.623 79.3183C102.582 79.3935 102.544 79.4652 102.507 79.5404C102.473 79.619 102.435 79.6908 102.404 79.7694C102.274 80.1179 102.288 80.3196 102.38 80.5144C102.609 81.0236 103.142 81.7139 103.457 82.1923C103.368 81.6113 103.375 81.3004 103.402 81.0817C103.474 80.5588 103.621 80.4973 103.969 79.9778C104.192 80.0906 104.414 80.1965 104.636 80.3127C104.369 79.8001 104.099 79.2909 103.833 78.7852C103.231 78.8262 102.637 78.8672 102.035 78.9116",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 45,
    width: 19,
    height: 11
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4908 55.8719L81.3188 46.1938L85.6453 45.7393L99.8172 55.4173L95.4908 55.8719Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.6453 45.7393L81.3188 46.1938L95.4908 55.8719L99.8172 55.4173L85.6453 45.7393Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 55,
    width: 5,
    height: 6
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5317 60.2194L95.501 55.852L99.8308 55.3975L99.8582 59.7649L95.5317 60.2194Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8308 55.3975L95.501 55.852L95.5317 60.2194L99.8582 59.7649L99.8308 55.3975Z",
    fill: "#843D47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3261 44.6083L68.0868 47.5848C67.974 47.5951 67.9398 47.742 68.0321 47.8035L82.0264 57.2322C82.0503 57.2492 82.0776 57.2561 82.105 57.2527L111.344 54.2761C111.457 54.2659 111.491 54.1189 111.399 54.0574L97.4047 44.6288C97.3808 44.6117 97.3534 44.6049 97.3261 44.6083Z",
    fill: "#192227"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 12,
    width: 15,
    height: 11
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5141 12.9798L111.816 22.6203C111.737 22.5657 111.638 22.5417 111.529 22.552L97.2271 12.9115C97.333 12.9012 97.4355 12.9252 97.5141 12.9798Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.529 22.5478L97.2271 12.9073C97.3057 12.9005 97.3808 12.9107 97.4458 12.9381L111.748 22.5786C111.683 22.5512 111.607 22.5376 111.529 22.5478Z",
    fill: "#BC485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.748 22.5819L97.4458 12.9414C97.4697 12.9517 97.4936 12.9653 97.5142 12.979L111.816 22.6195C111.795 22.6058 111.772 22.5921 111.748 22.5819Z",
    fill: "#B9475C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 46,
    width: 16,
    height: 11
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1358 56.8494L67.834 47.2089C67.7178 47.1303 67.646 46.997 67.6426 46.8398L81.9444 56.4803C81.9444 56.641 82.0196 56.7742 82.1358 56.8494Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.1358 56.8494L67.834 47.2089C67.7178 47.1303 67.646 46.997 67.6426 46.8398L81.9444 56.4803C81.9444 56.641 82.0196 56.7742 82.1358 56.8494Z",
    fill: "#A84153"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2042 25.6307L67.9023 15.9936L97.2271 12.9111L111.529 22.5482L82.2042 25.6307Z",
    fill: "#C14A5F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9444 56.4763L67.6425 46.8392L67.4307 16.5303L81.7359 26.1708L81.9444 56.4763Z",
    fill: "#A54052"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M111.529 22.5485C111.792 22.5211 112.004 22.7159 112.007 22.9893L112.219 53.2948C112.219 53.5648 112.011 53.8074 111.747 53.8348L82.4227 56.9173C82.1596 56.9446 81.9477 56.7498 81.9443 56.4764L81.7324 26.1709C81.7324 25.9009 81.9409 25.6583 82.204 25.631L111.529 22.5485Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 15,
    width: 16,
    height: 12
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7359 26.1707L67.4341 16.5302C67.4341 16.2602 67.6425 16.0176 67.9057 15.9902L82.2075 25.6307C81.9444 25.6581 81.7359 25.8973 81.7359 26.1707Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7359 26.1702L67.4341 16.5297C67.4341 16.4341 67.4614 16.3418 67.5058 16.2598L81.8077 25.9003C81.7633 25.9823 81.7359 26.0745 81.7359 26.1702Z",
    fill: "#A84153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8077 25.9007L67.5059 16.2602C67.5195 16.2363 67.5366 16.2124 67.5537 16.1885L81.8555 25.829C81.8384 25.8495 81.8214 25.8734 81.8077 25.9007Z",
    fill: "#AB4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8555 25.829L67.5537 16.1885C67.5674 16.1714 67.5845 16.1509 67.6016 16.1338L81.9034 25.7743C81.9034 25.7743 81.8692 25.8085 81.8555 25.829Z",
    fill: "#AE4356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9034 25.7777L67.6016 16.1372C67.6016 16.1372 67.6357 16.1064 67.6528 16.0928L81.9546 25.7333C81.9376 25.7469 81.9205 25.7606 81.9034 25.7777Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9512 25.7328L67.6494 16.0923C67.6665 16.0786 67.687 16.0649 67.7041 16.0547L82.0059 25.6952C81.9854 25.7054 81.9683 25.7191 81.9512 25.7328Z",
    fill: "#B34559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0093 25.6957L67.7075 16.0552C67.728 16.0415 67.7519 16.0312 67.7725 16.0244L82.0743 25.6649C82.0504 25.6752 82.0299 25.6854 82.0093 25.6957Z",
    fill: "#B6465A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0743 25.6649L67.7725 16.0244C67.7998 16.0142 67.8306 16.0039 67.8613 15.9971L82.1631 25.6376C82.1324 25.6444 82.1016 25.6512 82.0743 25.6649Z",
    fill: "#B9475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1632 25.6376L67.8613 15.9971C67.8613 15.9971 67.8887 15.9937 67.9023 15.9902L82.2042 25.6307C82.2042 25.6307 82.1768 25.6341 82.1632 25.6376Z",
    fill: "#BC485D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 38,
    width: 11,
    height: 16
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6909 47.5947L70.5508 38.4805L80.3929 44.6284L80.533 53.746L70.6909 47.5947Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.998 50.499L75.8681 42.2152L80.1672 44.9013L80.2971 53.1851L75.998 50.499ZM80.3928 44.6279L80.28 44.5562L75.7485 41.7231L75.6357 41.6514V41.8632L75.7759 50.5571V50.7656L75.892 50.8373L80.4235 53.6704L80.5363 53.7421V53.5337L80.3962 44.8398V44.6279",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0349 44.2324H78.028L77.9973 44.2666L77.9904 44.9467L78.0212 44.9637C77.6829 44.7587 77.2454 44.5297 76.8935 44.6733C76.8012 44.7074 76.7226 44.7724 76.644 44.8578C76.5688 44.9432 76.5005 45.0458 76.4458 45.1756C76.3911 45.3021 76.3467 45.449 76.3193 45.6165C76.3057 45.7053 76.2954 45.7908 76.2886 45.883C76.2817 45.9787 76.2817 46.1222 76.2817 46.2248C76.4902 46.2043 76.6132 46.2008 76.7328 46.276C76.8524 46.3512 76.9721 46.5016 77.1805 46.7852C77.3719 46.7408 77.5018 46.7408 77.6282 46.8194C77.741 46.8912 77.8572 47.0279 78.0144 47.25L78.0212 47.6601L78.0554 47.6806L78.1032 50.6469C78.1066 50.9203 78.2365 51.2244 78.3834 51.3167C78.5304 51.409 78.6534 51.262 78.65 50.9886L78.6432 50.4828L78.6056 50.394L78.5714 50.4384L78.5782 50.9442C78.5782 51.1458 78.4928 51.2518 78.3834 51.1834C78.2741 51.1151 78.1784 50.8964 78.1784 50.6947L78.1306 47.7284L78.1613 47.7489L78.1545 47.3388C78.3185 47.3115 78.4381 47.3149 78.5577 47.3901C78.6842 47.4687 78.8106 47.6293 78.9883 47.913C79.1592 47.8514 79.2891 47.848 79.4258 47.9335C79.5624 48.0189 79.7026 48.1898 79.8905 48.4734C79.8803 47.8344 79.665 46.9458 79.3369 46.3204C79.0088 45.7087 78.5646 45.2986 78.0759 44.9877L78.1066 45.0082L78.0759 44.3042L78.0451 44.2256",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9164 47.3247L70.7866 39.0409L75.0857 41.727L75.2155 50.0108L70.9164 47.3247ZM75.3078 41.4536L75.1916 41.3818L70.6636 38.5522L70.5474 38.4805V38.6923L70.6875 47.3862V47.5947L70.8071 47.6664L75.3351 50.4961L75.4513 50.5678V50.3594L75.3112 41.6655V41.4536",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6416 48.2101L71.4429 46.2109L71.4565 47.0209L74.6552 49.02L74.6416 48.2101Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2358 41.1221L71.7471 42.3113L72.0034 42.4719L72.0615 46.1491L72.5741 46.4703L72.516 42.7932L72.7723 42.9504L72.2358 41.1221Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6708 42.0176L73.1821 43.2103L73.4384 43.3675L73.4965 47.048L74.0091 47.3692L73.951 43.6887L74.2073 43.8493L73.6708 42.0176Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 42,
    width: 10,
    height: 11
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M101.324 52.8845L101.259 43.3739L109.974 42.458L110.039 51.9652L101.324 52.8845Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.376 45.0721C104.072 45.1028 103.771 45.2737 103.624 45.5607L103.118 46.5245L104.608 47.2558L105.534 45.4787L104.864 45.1507C104.718 45.0789 104.547 45.0516 104.376 45.0721Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.201 44.6348C105.685 44.6894 105.066 44.8159 104.625 44.8842C105.165 45.0448 105.422 45.1815 105.589 45.2977C105.986 45.578 105.948 45.7317 106.187 46.2649C105.965 46.4186 105.74 46.5724 105.517 46.7296C106.102 46.6989 106.683 46.6715 107.267 46.6408C107.575 46.0837 107.889 45.5165 108.2 44.9594C107.971 45.079 107.746 45.2055 107.52 45.3251C107.476 45.2601 107.438 45.1952 107.4 45.1269C107.356 45.0619 107.312 44.997 107.271 44.9355C107.048 44.6758 106.871 44.6074 106.659 44.6074C106.522 44.6074 106.365 44.6177 106.197 44.6348",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.741 52.4061L101.68 43.76L109.557 42.933L109.618 51.5791L101.741 52.4061ZM109.974 42.458L109.762 42.4785L101.468 43.3499L101.256 43.3705V43.5858L101.321 52.6658V52.8811L101.533 52.8606L109.827 51.9891L110.039 51.9686V51.7533L109.974 42.6733V42.458Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.138 46.2207L106.686 47.3006L107.677 48.8453L108.33 48.36C108.73 48.0661 108.928 47.4441 108.675 47.0614L108.135 46.2207",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.621 48.3398C106.321 48.8866 106.02 49.4334 105.719 49.9768C106.023 50.4825 106.324 50.9883 106.621 51.4941C106.649 51.2378 106.673 50.9849 106.693 50.7252C106.772 50.7183 106.854 50.7047 106.929 50.6944C107.008 50.6773 107.086 50.6637 107.161 50.6534C107.507 50.5509 107.667 50.4176 107.79 50.2194C108.108 49.7068 108.443 48.8114 108.696 48.2441C108.255 48.6747 107.995 48.8593 107.804 48.9618C107.595 49.0746 107.459 49.119 107.319 49.1361C107.144 49.1532 106.967 49.1292 106.645 49.1361C106.635 48.8695 106.628 48.603 106.621 48.3398Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.576 49.3676L103.583 50.1673C103.583 50.6526 103.976 51.1003 104.444 51.0524L105.459 50.9499L105.452 49.1797L103.58 49.3676",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.035 47.2558C102.23 47.3891 102.425 47.5258 102.623 47.6591C102.582 47.7343 102.544 47.806 102.507 47.8812C102.473 47.9598 102.435 48.0316 102.404 48.1102C102.274 48.4588 102.288 48.6604 102.38 48.8552C102.609 49.3644 103.142 50.0547 103.457 50.5331C103.368 49.9522 103.375 49.6412 103.402 49.4225C103.474 48.8996 103.621 48.8381 103.969 48.3187C104.192 48.4314 104.414 48.5374 104.636 48.6536C104.369 48.1409 104.099 47.6318 103.833 47.126C103.231 47.167 102.637 47.208 102.035 47.2524",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 14,
    width: 19,
    height: 11
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4908 24.2127L81.3188 14.5346L85.6453 14.0801L99.8172 23.7582L95.4908 24.2127Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.6453 14.0801L81.3188 14.5346L95.4908 24.2127L99.8172 23.7582L85.6453 14.0801Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 23,
    width: 5,
    height: 6
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5317 28.5602L95.501 24.1928L99.8308 23.7383L99.8582 28.1057L95.5317 28.5602Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8308 23.7383L95.501 24.1928L95.5317 28.5602L99.8582 28.1057L99.8308 23.7383Z",
    fill: "#843D47"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 37,
    width: 15,
    height: 11
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6152 37.8177L65.917 47.4582C65.8384 47.4035 65.7393 47.3796 65.6299 47.3899L51.3281 37.7494C51.4341 37.7391 51.5366 37.7631 51.6152 37.8177Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6299 47.3896L51.3281 37.7491C51.4067 37.7423 51.4819 37.7525 51.5468 37.7799L65.8487 47.4204C65.7837 47.393 65.7085 47.3794 65.6299 47.3896Z",
    fill: "#BC485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8521 47.4208L51.5503 37.7803C51.5742 37.7905 51.5981 37.8042 51.6186 37.8179L65.9205 47.4584C65.9 47.4447 65.876 47.431 65.8521 47.4208Z",
    fill: "#B9475C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 71,
    width: 16,
    height: 11
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2369 81.6873L21.935 72.0468C21.8188 71.9682 21.7471 71.8349 21.7437 71.6777L36.0455 81.3182C36.0455 81.4788 36.1207 81.6121 36.2369 81.6873Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2369 81.6873L21.935 72.0468C21.8188 71.9682 21.7471 71.8349 21.7437 71.6777L36.0455 81.3182C36.0455 81.4788 36.1207 81.6121 36.2369 81.6873Z",
    fill: "#A84153"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3057 50.472L22.0039 40.8315L51.3286 37.749L65.6305 47.3895L36.3057 50.472Z",
    fill: "#C14A5F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0493 81.3181L21.7441 71.6776L21.5322 41.3721L35.8375 51.0091L36.0493 81.3181Z",
    fill: "#A54052"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6303 47.3903C65.8934 47.3629 66.1053 47.5577 66.1087 47.8311L66.3206 78.1366C66.3206 78.4066 66.1122 78.6492 65.849 78.6766L36.5243 81.7591C36.2612 81.7864 36.0493 81.5916 36.0459 81.3182L35.834 51.0127C35.834 50.7427 36.0424 50.5001 36.3056 50.4728L65.6303 47.3903Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 40,
    width: 16,
    height: 12
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8375 51.0086L21.5356 41.3681C21.5356 41.0981 21.7441 40.8555 22.0072 40.8281L36.3091 50.4686C36.0459 50.496 35.8375 50.7352 35.8375 51.0086Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8375 51.0081L21.5356 41.3676C21.5356 41.2719 21.563 41.1797 21.6074 41.0977L35.9092 50.7381C35.8648 50.8202 35.8375 50.9124 35.8375 51.0081Z",
    fill: "#A84153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9092 50.7376L21.6074 41.0972C21.6211 41.0732 21.6382 41.0493 21.6553 41.0254L35.9571 50.6659C35.94 50.6864 35.9229 50.7103 35.9092 50.7376Z",
    fill: "#AB4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9571 50.6698L21.6553 41.0293C21.6689 41.0122 21.686 40.9917 21.7031 40.9746L36.0049 50.6151C36.0049 50.6151 35.9708 50.6493 35.9571 50.6698Z",
    fill: "#AE4356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.005 50.6146L21.7031 40.9741C21.7031 40.9741 21.7373 40.9434 21.7544 40.9297L36.0562 50.5702C36.0391 50.5838 36.022 50.5975 36.005 50.6146Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0562 50.5736L21.7544 40.9331C21.7715 40.9194 21.792 40.9058 21.8091 40.8955L36.1109 50.536C36.0904 50.5463 36.0733 50.5599 36.0562 50.5736Z",
    fill: "#B34559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1109 50.5365L21.8091 40.896C21.8296 40.8823 21.8535 40.8721 21.874 40.8652L36.1758 50.5057C36.1519 50.516 36.1314 50.5262 36.1109 50.5365Z",
    fill: "#B6465A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1758 50.5018L21.874 40.8613C21.9014 40.8511 21.9321 40.8408 21.9629 40.834L36.2647 50.4745C36.2339 50.4813 36.2032 50.4881 36.1758 50.5018Z",
    fill: "#B9475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2647 50.4784L21.9629 40.8379C21.9629 40.8379 21.9902 40.8345 22.0039 40.8311L36.3057 50.4715C36.3057 50.4715 36.2784 50.475 36.2647 50.4784Z",
    fill: "#BC485D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 63,
    width: 11,
    height: 16
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M24.792 72.436L24.6519 63.3184L34.494 69.4697L34.6341 78.5839L24.792 72.436Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0991 75.3408L29.9692 67.057L34.2683 69.7431L34.3982 78.0269L30.0991 75.3408ZM34.4938 69.4697L34.3811 69.398L29.8496 66.5649L29.7368 66.4932V66.705L29.8769 75.3989V75.6074L29.9931 75.6791L34.5246 78.5122L34.6374 78.5839V78.3755L34.4973 69.6816V69.4697",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1359 69.0732H32.1291L32.0983 69.1074L32.0915 69.7875L32.1223 69.8046C31.7839 69.5995 31.3465 69.3706 30.9945 69.5141C30.9023 69.5483 30.8237 69.6132 30.7451 69.6986C30.6699 69.7841 30.6015 69.8866 30.5468 70.0164C30.4922 70.1429 30.4477 70.2898 30.4204 70.4573C30.4067 70.5461 30.3965 70.6316 30.3896 70.7238C30.3828 70.8195 30.3828 70.9631 30.3828 71.0656C30.5913 71.0451 30.7143 71.0417 30.8339 71.1168C30.9535 71.192 31.0731 71.3424 31.2816 71.626C31.473 71.5816 31.6028 71.5816 31.7293 71.6602C31.842 71.732 31.9582 71.8687 32.1154 72.0908L32.1223 72.5009L32.1564 72.5214L32.2043 75.4877C32.2077 75.7611 32.3376 76.0652 32.4845 76.1575C32.6315 76.2498 32.7545 76.1028 32.7511 75.8294L32.7442 75.3237L32.7066 75.2348L32.6725 75.2792L32.6793 75.785C32.6793 75.9866 32.5939 76.0926 32.4845 76.0242C32.3752 75.9559 32.2795 75.7372 32.2795 75.5355L32.2316 72.5692L32.2624 72.5897L32.2555 72.1797C32.4196 72.1523 32.5392 72.1557 32.6588 72.2309C32.7852 72.3095 32.9117 72.4701 33.0894 72.7538C33.2603 72.6923 33.3901 72.6888 33.5268 72.7743C33.6635 72.8597 33.8036 73.0306 33.9916 73.3142C33.9813 72.6752 33.766 71.7867 33.438 71.1613C33.1099 70.5496 32.6656 70.1395 32.1769 69.8285L32.2077 69.849L32.1769 69.145L32.1462 69.0664",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0175 72.166L24.8877 63.8822L29.1867 66.5683L29.3166 74.8521L25.0175 72.166ZM29.4123 66.2915L29.2961 66.2197L24.768 63.3901L24.6519 63.3184V63.5302L24.792 72.2241V72.4326L24.9116 72.5043L29.4396 75.3339L29.5558 75.4057V75.1972L29.4157 66.5034V66.2915",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7426 73.0509L25.5439 71.0518L25.5576 71.8583L28.7563 73.8574L28.7426 73.0509Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3368 65.96L25.8481 67.1526L26.1044 67.3098L26.1625 70.9904L26.6752 71.3116L26.6171 67.6311L26.8734 67.7917L26.3368 65.96Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7753 66.8584L27.2866 68.0477L27.5429 68.2083L27.5976 71.8854L28.1102 72.2066L28.0521 68.5295L28.3084 68.6867L27.7753 66.8584Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 67,
    width: 10,
    height: 11
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4263 77.7224L55.3613 68.2118L64.0757 67.2959L64.144 76.8065L55.4263 77.7224Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4778 69.9139C58.1737 69.9446 57.8729 70.1155 57.726 70.4025L57.2202 71.3662L58.7102 72.0976L59.6363 70.3205L58.9665 69.9925C58.8196 69.9207 58.6487 69.8933 58.4778 69.9139Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.303 69.4766C59.7869 69.5312 59.1684 69.6577 58.7275 69.726C59.2675 69.8866 59.5238 70.0233 59.6912 70.1395C60.0877 70.4198 60.0501 70.5735 60.2893 71.1067C60.0672 71.2604 59.8416 71.4142 59.6195 71.5714C60.2039 71.5407 60.7848 71.5133 61.3692 71.4826C61.6768 70.9255 61.9912 70.3582 62.3021 69.8012C62.0732 69.9208 61.8476 70.0473 61.6221 70.1669C61.5777 70.1019 61.5401 70.037 61.5025 69.9687C61.458 69.9037 61.4136 69.8388 61.3726 69.7773C61.1505 69.5176 60.9728 69.4492 60.7609 69.4492C60.6242 69.4492 60.467 69.4595 60.2995 69.4766",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8432 77.2474L55.7817 68.6013L63.6588 67.7743L63.7203 76.4204L55.8432 77.2474ZM64.0757 67.2959L63.8638 67.3164L55.5698 68.1878L55.3579 68.2083V68.4236L55.4228 77.5037V77.719L55.6347 77.6985L63.9288 76.827L64.1406 76.8065V76.5912L64.0757 67.5112V67.2959Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2405 71.0615L60.7881 72.1414L61.7791 73.6861L62.4319 73.2008C62.8317 72.9069 63.0299 72.285 62.777 71.9022L62.2371 71.0615",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7264 73.1806C60.4257 73.7274 60.125 74.2742 59.8242 74.8176C60.1284 75.3234 60.4291 75.8291 60.7264 76.3349C60.7538 76.0786 60.7777 75.8257 60.7982 75.566C60.8768 75.5592 60.9588 75.5455 61.034 75.5352C61.1126 75.5182 61.1912 75.5045 61.2664 75.4942C61.6115 75.3917 61.7721 75.2584 61.8952 75.0602C62.213 74.5476 62.5479 73.6522 62.8008 73.085C62.3599 73.5156 62.1002 73.7001 61.9088 73.8026C61.7004 73.9154 61.5637 73.9598 61.4236 73.9769C61.2493 73.994 61.0716 73.9701 60.7503 73.9769C60.7401 73.7103 60.7332 73.4438 60.7264 73.1806Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6782 74.2055L57.6851 75.0052C57.6851 75.4905 58.0781 75.9382 58.5462 75.8903L59.5612 75.7878L59.5544 74.0176L57.6816 74.2055",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1372 72.0976C56.332 72.2309 56.5268 72.3676 56.725 72.5009C56.684 72.5761 56.6464 72.6478 56.6088 72.723C56.5746 72.8016 56.537 72.8734 56.5063 72.952C56.3764 73.3006 56.3901 73.5022 56.4824 73.697C56.7113 74.2062 57.2444 74.8965 57.5588 75.3749C57.47 74.794 57.4768 74.483 57.5042 74.2643C57.5759 73.7414 57.7229 73.6799 58.0715 73.1604C58.2936 73.2732 58.5157 73.3792 58.7378 73.4954C58.4713 72.9827 58.2013 72.4735 57.9348 71.9678C57.3333 72.0088 56.7387 72.0498 56.1372 72.0942",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 38,
    width: 19,
    height: 12
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5924 49.0515L35.4204 39.3735L39.7468 38.9189L53.9222 48.597L49.5924 49.0515Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7468 38.9189L35.4204 39.3735L49.5924 49.0515L53.9222 48.597L39.7468 38.9189Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 48,
    width: 5,
    height: 6
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6333 53.4015L49.6025 49.0307L53.9324 48.5762L53.9631 52.947L49.6333 53.4015Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9324 48.5762L49.6025 49.0307L49.6333 53.4015L53.9631 52.947L53.9324 48.5762Z",
    fill: "#843D47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4276 37.7909L22.1883 40.7674C22.0756 40.7777 22.0414 40.9247 22.1337 40.9862L36.1279 50.4148C36.1519 50.4319 36.1792 50.4387 36.2065 50.4353L65.4458 47.4587C65.5586 47.4485 65.5928 47.3015 65.5005 47.24L51.5062 37.8114C51.4823 37.7943 51.455 37.7875 51.4276 37.7909Z",
    fill: "#192227"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 6,
    width: 15,
    height: 10
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6152 6.15856L65.917 15.799C65.8384 15.7444 65.7393 15.7204 65.6299 15.7307L51.3281 6.09021C51.4341 6.07996 51.5366 6.10388 51.6152 6.15856Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6299 15.7304L51.3281 6.08994C51.4067 6.08311 51.4819 6.09336 51.5468 6.1207L65.8487 15.7612C65.7837 15.7338 65.7085 15.7202 65.6299 15.7304Z",
    fill: "#BC485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8521 15.7616L51.5503 6.12109C51.5742 6.13135 51.5981 6.14502 51.6186 6.15869L65.9205 15.7992C65.9 15.7855 65.876 15.7718 65.8521 15.7616Z",
    fill: "#B9475C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 40,
    width: 16,
    height: 11
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2369 50.0281L21.935 40.3876C21.8188 40.309 21.7471 40.1758 21.7437 40.0186L36.0455 49.659C36.0455 49.8197 36.1207 49.9529 36.2369 50.0281Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2369 50.0281L21.935 40.3876C21.8188 40.309 21.7471 40.1758 21.7437 40.0186L36.0455 49.659C36.0455 49.8197 36.1207 49.9529 36.2369 50.0281Z",
    fill: "#A84153"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3057 18.8128L22.0039 9.17234L51.3286 6.08984L65.6305 15.7303L36.3057 18.8128Z",
    fill: "#C14A5F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0493 49.6589L21.7441 40.0184L21.5322 9.71289L35.8375 19.35L36.0493 49.6589Z",
    fill: "#A54052"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6303 15.7311C65.8934 15.7037 66.1053 15.8985 66.1087 16.1719L66.3206 46.4774C66.3206 46.7474 66.1122 46.99 65.849 47.0174L36.5243 50.0999C36.2612 50.1272 36.0493 49.9324 36.0459 49.659L35.834 19.3535C35.834 19.0835 36.0424 18.8409 36.3056 18.8136L65.6303 15.7311Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 9,
    width: 16,
    height: 11
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8375 19.3494L21.5356 9.70889C21.5356 9.43892 21.7441 9.19628 22.0072 9.16895L36.3091 18.8094C36.0459 18.8368 35.8375 19.076 35.8375 19.3494Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8375 19.3489L21.5356 9.70845C21.5356 9.61276 21.563 9.52049 21.6074 9.43848L35.9092 19.079C35.8648 19.161 35.8375 19.2533 35.8375 19.3489Z",
    fill: "#A84153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9092 19.0794L21.6074 9.43895C21.6211 9.41503 21.6382 9.39111 21.6553 9.36719L35.9571 19.0077C35.94 19.0282 35.9229 19.0521 35.9092 19.0794Z",
    fill: "#AB4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9571 19.0106L21.6553 9.37011C21.6689 9.35302 21.686 9.33252 21.7031 9.31543L36.0049 18.9559C36.0049 18.9559 35.9708 18.9901 35.9571 19.0106Z",
    fill: "#AE4356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.005 18.9564L21.7031 9.31591C21.7031 9.31591 21.7373 9.28515 21.7544 9.27148L36.0562 18.912C36.0391 18.9256 36.022 18.9393 36.005 18.9564Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0562 18.9115L21.7544 9.27099C21.7715 9.25732 21.792 9.24365 21.8091 9.2334L36.1109 18.8739C36.0904 18.8841 36.0733 18.8978 36.0562 18.9115Z",
    fill: "#B34559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1109 18.8773L21.8091 9.23681C21.8296 9.22314 21.8535 9.21289 21.874 9.20605L36.1758 18.8465C36.1519 18.8568 36.1314 18.867 36.1109 18.8773Z",
    fill: "#B6465A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1758 18.8436L21.874 9.20312C21.9014 9.19287 21.9321 9.18262 21.9629 9.17578L36.2647 18.8163C36.2339 18.8231 36.2032 18.8299 36.1758 18.8436Z",
    fill: "#B9475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2647 18.8163L21.9629 9.17578C21.9629 9.17578 21.9902 9.17236 22.0039 9.16895L36.3057 18.8094C36.3057 18.8094 36.2784 18.8129 36.2647 18.8163Z",
    fill: "#BC485D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 31,
    width: 11,
    height: 16
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7925 40.7768L24.6523 31.6592L34.4945 37.8105L34.6346 46.9247L24.7925 40.7768Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0995 43.6816L29.9697 35.3979L34.2688 38.0839L34.3986 46.3677L30.0995 43.6816ZM34.4943 37.8105L34.3816 37.7388L29.8501 34.9057L29.7373 34.834V35.0459L29.8774 43.7397V43.9482L29.9936 44.02L34.5251 46.853L34.6379 46.9247V46.7163L34.4977 38.0224V37.8105",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1364 37.4141H32.1296L32.0988 37.4482L32.092 38.1283L32.1228 38.1454C31.7844 37.9403 31.347 37.7114 30.995 37.8549C30.9027 37.8891 30.8241 37.954 30.7455 38.0394C30.6704 38.1249 30.602 38.2274 30.5473 38.3573C30.4927 38.4837 30.4482 38.6307 30.4209 38.7981C30.4072 38.887 30.397 38.9724 30.3901 39.0647C30.3833 39.1604 30.3833 39.3039 30.3833 39.4064C30.5918 39.3859 30.7148 39.3825 30.8344 39.4577C30.954 39.5329 31.0736 39.6832 31.2821 39.9669C31.4735 39.9224 31.6033 39.9224 31.7298 40.001C31.8425 40.0728 31.9587 40.2095 32.1159 40.4316L32.1228 40.8417L32.1569 40.8622L32.2048 43.8285C32.2082 44.1019 32.3381 44.4061 32.485 44.4983C32.6319 44.5906 32.755 44.4437 32.7516 44.1703L32.7447 43.6645L32.7071 43.5756L32.673 43.6201L32.6798 44.1258C32.6798 44.3275 32.5944 44.4334 32.485 44.3651C32.3756 44.2967 32.28 44.078 32.28 43.8764L32.2321 40.9101L32.2629 40.9306L32.256 40.5205C32.4201 40.4931 32.5397 40.4966 32.6593 40.5717C32.7857 40.6503 32.9122 40.811 33.0899 41.0946C33.2608 41.0331 33.3906 41.0297 33.5273 41.1151C33.664 41.2005 33.8041 41.3714 33.9921 41.6551C33.9818 41.016 33.7665 40.1275 33.4385 39.5021C33.1104 38.8904 32.6661 38.4803 32.1774 38.1693L32.2082 38.1898L32.1774 37.4858L32.1467 37.4072",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.018 40.5034L24.8881 32.2196L29.1872 34.9057L29.3171 43.1895L25.018 40.5034ZM29.4128 34.6323L29.2966 34.5606L24.7685 31.7309L24.6523 31.6592V31.8711L24.7925 40.5649V40.7734L24.9121 40.8452L29.4401 43.6748L29.5563 43.7465V43.5381L29.4162 34.8442V34.6323",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7431 41.3918L25.5444 39.3926L25.5581 40.1991L28.7568 42.1983L28.7431 41.3918Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3373 34.3008L25.8486 35.49L26.1049 35.6507L26.163 39.3312L26.6756 39.6524L26.6175 35.9719L26.8739 36.1325L26.3373 34.3008Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7758 35.1992L27.2871 36.3885L27.5434 36.5491L27.5981 40.2262L28.1107 40.5475L28.0526 36.8703L28.3089 37.0275L27.7758 35.1992Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 35,
    width: 10,
    height: 12
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4263 46.0632L55.3613 36.5526L64.0757 35.6367L64.144 45.1473L55.4263 46.0632Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4778 38.2547C58.1737 38.2854 57.8729 38.4563 57.726 38.7434L57.2202 39.7071L58.7102 40.4384L59.6363 38.6613L58.9665 38.3333C58.8196 38.2615 58.6487 38.2342 58.4778 38.2547Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.303 37.8174C59.7869 37.8721 59.1684 37.9985 58.7275 38.0668C59.2675 38.2275 59.5238 38.3642 59.6912 38.4804C60.0877 38.7606 60.0501 38.9144 60.2893 39.4475C60.0672 39.6013 59.8416 39.755 59.6195 39.9122C60.2039 39.8815 60.7848 39.8541 61.3692 39.8234C61.6768 39.2664 61.9912 38.6991 62.3021 38.142C62.0732 38.2616 61.8476 38.3881 61.6221 38.5077C61.5777 38.4428 61.5401 38.3778 61.5025 38.3095C61.458 38.2446 61.4136 38.1796 61.3726 38.1181C61.1505 37.8584 60.9728 37.79 60.7609 37.79C60.6242 37.79 60.467 37.8003 60.2995 37.8174",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8432 45.5882L55.7817 36.9422L63.6588 36.1152L63.7203 44.7612L55.8432 45.5882ZM64.0757 35.6367L63.8638 35.6572L55.5698 36.5287L55.3579 36.5492V36.7645L55.4228 45.8445V46.0598L55.6347 46.0393L63.9288 45.1679L64.1406 45.1473V44.932L64.0757 35.852V35.6367Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2405 39.4023L60.7881 40.4822L61.7791 42.0269L62.4319 41.5416C62.8317 41.2477 63.0299 40.6258 62.777 40.243L62.2371 39.4023",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7264 41.5185C60.4257 42.0653 60.125 42.6121 59.8242 43.1555C60.1284 43.6612 60.4291 44.167 60.7264 44.6728C60.7538 44.4165 60.7777 44.1636 60.7982 43.9039C60.8768 43.8971 60.9588 43.8834 61.034 43.8731C61.1126 43.856 61.1912 43.8424 61.2664 43.8321C61.6115 43.7296 61.7721 43.5963 61.8952 43.3981C62.213 42.8855 62.5479 41.9901 62.8008 41.4229C62.3599 41.8534 62.1002 42.038 61.9088 42.1405C61.7004 42.2533 61.5637 42.2977 61.4236 42.3148C61.2493 42.3319 61.0716 42.308 60.7503 42.3148C60.7401 42.0482 60.7332 41.7817 60.7264 41.5185Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6782 42.5464L57.6851 43.346C57.6851 43.8313 58.0781 44.279 58.5462 44.2311L59.5612 44.1286L59.5544 42.3584L57.6816 42.5464",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1372 40.4385C56.332 40.5717 56.5268 40.7084 56.725 40.8417C56.684 40.9169 56.6464 40.9887 56.6088 41.0638C56.5746 41.1424 56.537 41.2142 56.5063 41.2928C56.3764 41.6414 56.3901 41.843 56.4824 42.0378C56.7113 42.547 57.2444 43.2373 57.5588 43.7157C57.47 43.1348 57.4768 42.8238 57.5042 42.6051C57.5759 42.0822 57.7229 42.0207 58.0715 41.5013C58.2936 41.614 58.5157 41.72 58.7378 41.8362C58.4713 41.3236 58.2013 40.8144 57.9348 40.3086C57.3333 40.3496 56.7387 40.3906 56.1372 40.435",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 7,
    width: 19,
    height: 11
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5924 17.3914L35.4204 7.7133L39.7468 7.25879L53.9222 16.9369L49.5924 17.3914Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7468 7.25879L35.4204 7.7133L49.5924 17.3914L53.9222 16.9369L39.7468 7.25879Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 16,
    width: 5,
    height: 6
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6333 21.7424L49.6025 17.3715L53.9324 16.917L53.9631 21.2878L49.6333 21.7424Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9324 16.917L49.6025 17.3715L49.6333 21.7424L53.9631 21.2878L53.9324 16.917Z",
    fill: "#843D47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 15,
    width: 32,
    height: 67
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7075 81.7176L35.8203 18.7144L66.119 15.7959L66.0062 78.7991L35.7075 81.7176Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7738 15.8305L36.1621 18.6806C35.9707 18.6977 35.8203 18.8754 35.8203 19.0701L35.9878 81.3318C35.9878 81.53 36.1415 81.6735 36.3329 81.6564L65.6645 78.7824C65.8559 78.7653 66.0096 78.5876 66.0096 78.3928L66.119 16.1551C66.119 15.9603 65.9652 15.8134 65.7738 15.8305Z",
    fill: "#192227"
  })))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M143.691 40.3873L145.902 41.5971L143.691 42.8068L142.484 45.0145L141.275 42.8068L139.067 41.5971L141.275 40.3873L142.484 38.1797L143.691 40.3873Z",
    fill: "#FFD485"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M140.154 54.1794L142.143 55.2661L140.154 56.3528L139.067 58.3418L137.977 56.3528L135.991 55.2661L137.977 54.1794L139.067 52.1904L140.154 54.1794Z",
    fill: "#FFD485"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 28,
    width: 28,
    height: 28
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M128.995 32.4458L130.383 33.8264C128.018 31.4718 124.741 30.016 120.995 29.9613C112.835 29.8451 105.494 36.4271 104.629 44.6357C104.161 49.0749 105.685 53.0971 108.474 55.8721L107.087 54.4914C104.298 51.7165 102.777 47.6942 103.242 43.255C104.107 35.0464 111.447 28.4611 119.608 28.5807C123.353 28.6354 126.631 30.0912 128.995 32.4458Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.996 32.4457L130.383 33.8264C128.018 31.4718 124.741 30.0159 120.996 29.9613C118.378 29.9237 115.846 30.5764 113.583 31.7486L112.196 30.3679C114.458 29.1958 116.99 28.543 119.608 28.5806C123.354 28.6353 126.631 30.0911 128.996 32.4457Z",
    fill: "#C29851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.195 30.3682L113.583 31.7488C112.94 32.0803 112.322 32.4562 111.727 32.8697L110.34 31.4891C110.934 31.0756 111.553 30.7031 112.195 30.3682Z",
    fill: "#C49A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34 31.4893L111.728 32.8699C111.242 33.2082 110.778 33.5705 110.33 33.9532L108.942 32.5726C109.39 32.1864 109.858 31.8242 110.34 31.4893Z",
    fill: "#C79C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.942 32.5723L110.33 33.9529C109.923 34.3015 109.533 34.6706 109.164 35.0567L107.777 33.6761C108.149 33.2899 108.539 32.9208 108.942 32.5723Z",
    fill: "#C99E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.777 33.6797L109.165 35.0603C108.813 35.426 108.478 35.8053 108.16 36.2017L106.772 34.8211C107.09 34.4247 107.425 34.0453 107.777 33.6797Z",
    fill: "#CCA055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.772 34.8213L108.16 36.2019C107.845 36.5915 107.548 36.9982 107.271 37.4151L105.884 36.0345C106.161 35.6175 106.458 35.2143 106.772 34.8213Z",
    fill: "#CFA256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.884 36.0303L107.271 37.4109C106.987 37.8347 106.724 38.2755 106.478 38.7266L105.091 37.346C105.333 36.8949 105.6 36.4574 105.884 36.0303Z",
    fill: "#D1A457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.091 37.3467L106.478 38.7273C106.215 39.2092 105.979 39.7081 105.767 40.2173L104.38 38.8367C104.592 38.3275 104.831 37.832 105.091 37.3467Z",
    fill: "#D4A658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.377 38.833L105.764 40.2136C105.522 40.798 105.31 41.3961 105.136 42.0112L103.748 40.6306C103.922 40.0188 104.131 39.4174 104.377 38.833Z",
    fill: "#D6A859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.748 40.6309L105.135 42.0115C104.893 42.8624 104.722 43.7407 104.626 44.6395C104.626 44.6395 104.626 44.6395 104.626 44.6429L103.239 43.2623C103.239 43.2623 103.239 43.2623 103.239 43.2588C103.334 42.3601 103.505 41.4818 103.748 40.6309Z",
    fill: "#D9AA5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.239 43.2617L104.626 44.6424C104.414 46.6552 104.612 48.5792 105.149 50.3426L103.762 48.9619C103.222 47.1986 103.027 45.2746 103.239 43.2617Z",
    fill: "#DBAC5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.765 48.9658L105.153 50.3465C105.405 51.1735 105.734 51.9663 106.13 52.7113L104.743 51.3307C104.346 50.5823 104.018 49.7928 103.765 48.9658Z",
    fill: "#D9AA5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.742 51.3301L106.13 52.7107C106.413 53.2438 106.731 53.7564 107.08 54.2451L105.692 52.8645C105.34 52.3792 105.022 51.8666 104.742 51.3301Z",
    fill: "#D6A859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.692 52.8613L107.08 54.242C107.381 54.6589 107.705 55.0587 108.054 55.4381L106.666 54.0574C106.318 53.6781 105.993 53.2783 105.692 52.8613Z",
    fill: "#D4A658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.667 54.0576L108.054 55.4383C108.191 55.5886 108.331 55.7321 108.474 55.8757L107.087 54.495C106.943 54.3515 106.803 54.208 106.667 54.0576Z",
    fill: "#D1A457"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 32,
    width: 5,
    height: 5
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M130.38 33.8264C131.237 34.6774 131.972 35.6479 132.57 36.7107C132.109 36.2494 131.644 35.7914 131.183 35.3301C130.585 34.2673 129.85 33.3002 128.992 32.4492C129.409 32.8627 129.963 33.4129 130.38 33.8298V33.8264Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.996 32.4463L130.383 33.8269C130.527 33.9705 130.667 34.114 130.803 34.2643L129.416 32.8837C129.279 32.7334 129.139 32.5898 128.996 32.4463Z",
    fill: "#93733D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.413 32.8838L130.8 34.2644C131.149 34.6438 131.473 35.0436 131.774 35.4605L130.387 34.0799C130.086 33.663 129.761 33.2631 129.413 32.8838Z",
    fill: "#95743D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.387 34.0801L131.774 35.4607C132.126 35.946 132.444 36.4586 132.724 36.9951L131.337 35.6145C131.053 35.0814 130.735 34.5688 130.387 34.0801Z",
    fill: "#96763E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 54,
    width: 6,
    height: 5
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M112.226 58.4832C110.815 57.8305 109.55 56.9454 108.474 55.8757L107.086 54.4951C108.163 55.5648 109.427 56.4499 110.839 57.1026C111.3 57.5639 111.761 58.0219 112.226 58.4832Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.883 56.5695L125.27 57.9501C123.008 59.1223 120.476 59.775 117.858 59.7374C114.113 59.6827 110.835 58.2269 108.47 55.8757L107.083 54.4951C109.448 56.8497 112.725 58.3055 116.471 58.3568C119.088 58.3944 121.621 57.7416 123.883 56.5695Z",
    fill: "#886A38"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 35,
    width: 25,
    height: 25
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M117.855 59.7367C115.815 59.7059 113.915 59.2617 112.223 58.4825C112.175 58.4346 112.11 58.3697 112.062 58.3219C112.011 58.2706 111.943 58.2023 111.891 58.151C111.84 58.0997 111.768 58.028 111.714 57.9733C111.659 57.9186 111.587 57.8468 111.533 57.7922C111.478 57.7375 111.406 57.6657 111.351 57.611C111.297 57.5564 111.228 57.488 111.174 57.4333C111.119 57.3787 111.054 57.3137 111.003 57.2625C110.955 57.2146 110.89 57.1497 110.842 57.1019C112.534 57.881 114.434 58.3287 116.474 58.356C124.635 58.4722 131.979 51.8903 132.844 43.6817C133.168 40.6026 132.536 37.7252 131.189 35.3262C131.343 35.48 132.143 36.266 132.577 36.7068C133.923 39.1058 134.556 41.9833 134.231 45.0623C133.366 53.2709 126.022 59.8529 117.862 59.7367H117.855Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.386 34.0791L131.774 35.4597C132.126 35.945 132.444 36.4576 132.724 36.9941L131.336 35.6135C131.053 35.0804 130.735 34.5678 130.386 34.0791Z",
    fill: "#96763E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34 35.6133L132.727 36.9939C133.124 37.7423 133.452 38.5317 133.705 39.3588L132.317 37.9781C132.064 37.1511 131.736 36.3583 131.34 35.6133Z",
    fill: "#98773F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.313 37.9785L133.701 39.3591C134.241 41.1225 134.436 43.0465 134.224 45.0594L132.836 43.6787C133.048 41.6659 132.85 39.7419 132.313 37.9785Z",
    fill: "#9A7840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.84 43.6787L134.227 45.0593C134.227 45.0593 134.227 45.0593 134.227 45.0628C134.132 45.9581 133.961 46.8364 133.718 47.6873L132.331 46.3067C132.573 45.4558 132.744 44.5775 132.84 43.6821C132.84 43.6821 132.84 43.6821 132.84 43.6787Z",
    fill: "#98773F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.331 46.3105L133.718 47.6912C133.544 48.3029 133.336 48.9009 133.09 49.4853L131.702 48.1047C131.945 47.5203 132.157 46.9223 132.331 46.3105Z",
    fill: "#96763E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.702 48.1045L133.09 49.4851C132.878 49.9943 132.638 50.4898 132.379 50.9717L130.991 49.5911C131.254 49.1092 131.49 48.6103 131.702 48.1045Z",
    fill: "#95743D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.991 49.5938L132.379 50.9744C132.136 51.4255 131.869 51.8629 131.586 52.2867L130.198 50.906C130.482 50.4823 130.745 50.0414 130.991 49.5938Z",
    fill: "#93733D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.198 50.9062L131.586 52.2869C131.309 52.7038 131.011 53.1071 130.697 53.5001L129.31 52.1194C129.624 51.7298 129.921 51.3232 130.198 50.9062Z",
    fill: "#91713C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.31 52.1201L130.697 53.5008C130.38 53.8972 130.045 54.2765 129.693 54.6422L128.305 53.2615C128.657 52.8959 128.992 52.5165 129.31 52.1201Z",
    fill: "#8F703B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.305 53.2607L129.692 54.6414C129.32 55.0275 128.93 55.3966 128.527 55.7452L127.14 54.3646C127.546 54.016 127.936 53.6469 128.305 53.2607Z",
    fill: "#8D6F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.14 54.3652L128.527 55.7459C128.08 56.132 127.612 56.4943 127.126 56.8326L125.739 55.452C126.224 55.1136 126.692 54.7514 127.14 54.3652Z",
    fill: "#8C6D3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.738 55.4512L127.126 56.8318C126.531 57.2453 125.913 57.6178 125.27 57.9527L123.883 56.5721C124.525 56.2406 125.144 55.8647 125.738 55.4512Z",
    fill: "#8A6C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.883 56.5695L125.27 57.9501C123.008 59.1223 120.476 59.775 117.858 59.7374C114.113 59.6827 110.835 58.2269 108.47 55.8757L107.083 54.4951C109.448 56.8497 112.725 58.3055 116.471 58.3568C119.088 58.3944 121.621 57.7416 123.883 56.5695Z",
    fill: "#886A38"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M119.608 28.584C127.769 28.7002 133.705 35.4769 132.84 43.6855C131.975 51.8941 124.631 58.476 116.471 58.3598C108.31 58.2436 102.377 51.4669 103.242 43.2617C104.107 35.0531 111.447 28.4678 119.608 28.5874V28.584Z",
    fill: "#A38044"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M119.779 26.947C128.835 27.0769 135.424 34.5952 134.463 43.706C133.503 52.8167 125.356 60.1231 116.297 59.9933C107.24 59.8634 100.652 52.3451 101.612 43.2344C102.572 34.1236 110.719 26.8172 119.779 26.947ZM116.471 58.3564C124.632 58.4725 131.976 51.8906 132.84 43.682C133.705 35.4734 127.769 28.6967 119.608 28.5805C111.447 28.4643 104.107 35.0463 103.242 43.2549C102.378 51.4635 108.31 58.2367 116.471 58.3529",
    fill: "#E9B761"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 31,
    width: 31,
    height: 31
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M130.199 31.2363L131.586 32.617C134.682 35.696 136.37 40.1592 135.851 45.0905C134.891 54.2013 126.744 61.5077 117.684 61.3778C113.529 61.3163 109.892 59.7033 107.264 57.089L105.877 55.7083C108.502 58.3192 112.138 59.9357 116.297 59.9972C125.353 60.127 133.503 52.8206 134.464 43.7098C134.983 38.7785 133.291 34.3154 130.199 31.2363Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.199 31.2363L131.586 32.617C131.743 32.7742 131.901 32.9348 132.051 33.1022L130.663 31.7216C130.513 31.5576 130.356 31.3935 130.199 31.2363Z",
    fill: "#D1A457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.664 31.7217L132.051 33.1023C132.437 33.5227 132.796 33.9669 133.131 34.4317L131.743 33.051C131.409 32.5863 131.05 32.1454 130.664 31.7217Z",
    fill: "#D4A658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.743 33.0479L133.131 34.4285C133.52 34.9684 133.872 35.5357 134.187 36.1303L132.799 34.7497C132.485 34.1551 132.133 33.5878 131.743 33.0479Z",
    fill: "#D6A859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.799 34.749L134.187 36.1297C134.628 36.9601 134.99 37.8384 135.27 38.7542L133.883 37.3736C133.602 36.4543 133.237 35.576 132.799 34.749Z",
    fill: "#D9AA5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.882 37.377L135.27 38.7576C135.868 40.7123 136.087 42.8516 135.851 45.0832L134.463 43.7026C134.699 41.471 134.48 39.3317 133.882 37.377Z",
    fill: "#DBAC5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.463 43.7031L135.851 45.0838C135.851 45.0838 135.851 45.0872 135.851 45.0906C135.745 46.0851 135.553 47.0624 135.287 48.0056L133.899 46.625C134.169 45.6784 134.357 44.7044 134.463 43.71C134.463 43.71 134.463 43.7065 134.463 43.7031Z",
    fill: "#D9AA5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.9 46.625L135.287 48.0056C135.092 48.6857 134.86 49.3521 134.59 49.998L133.203 48.6173C133.473 47.9715 133.705 47.3051 133.9 46.625Z",
    fill: "#D6A859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.203 48.6172L134.59 49.9978C134.354 50.5617 134.091 51.1119 133.801 51.6484L132.413 50.2678C132.704 49.7313 132.967 49.1811 133.203 48.6172Z",
    fill: "#D4A658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.413 50.2676L133.8 51.6482C133.53 52.1472 133.237 52.6358 132.922 53.1074L131.535 51.7268C131.849 51.2552 132.143 50.7699 132.413 50.2676Z",
    fill: "#D1A457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.532 51.7275L132.919 53.1082C132.611 53.5695 132.28 54.0206 131.931 54.4546L130.544 53.074C130.893 52.64 131.221 52.1923 131.532 51.7275Z",
    fill: "#CFA256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.547 53.0732L131.935 54.4539C131.583 54.8913 131.21 55.3151 130.821 55.7217L129.433 54.3411C129.823 53.9344 130.195 53.5141 130.547 53.0732Z",
    fill: "#CCA055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.429 54.3379L130.817 55.7185C130.403 56.1457 129.973 56.5558 129.522 56.9454L128.134 55.5647C128.585 55.1752 129.016 54.7685 129.429 54.3379Z",
    fill: "#C99E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.135 55.5645L129.522 56.9451C129.026 57.3723 128.507 57.7755 127.97 58.148L126.583 56.7674C127.12 56.3949 127.639 55.9916 128.135 55.5645Z",
    fill: "#C79C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.583 56.7676L127.971 58.1482C127.311 58.6061 126.624 59.0231 125.913 59.3921L124.526 58.0115C125.237 57.6424 125.927 57.2255 126.583 56.7676Z",
    fill: "#C49A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.526 58.0118L125.913 59.3925C123.401 60.6945 120.592 61.419 117.687 61.3745C113.532 61.313 109.896 59.7 107.268 57.0857L105.88 55.7051C108.505 58.316 112.141 59.9324 116.3 59.9939C119.205 60.0349 122.017 59.3139 124.526 58.0118Z",
    fill: "#C29851"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 29,
    width: 31,
    height: 29
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M103.092 57.1868L105.419 29.417H133.049L130.721 57.1868H103.092Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.78 48.117C118.402 48.117 118.87 47.9769 119.195 47.7035C119.516 47.4301 119.694 47.0884 119.728 46.6851C119.752 46.3912 119.683 46.1452 119.516 45.9401C119.348 45.7385 119.109 45.5608 118.802 45.407C118.491 45.2566 117.999 45.0448 117.329 44.7748C116.56 44.4946 115.921 44.2041 115.412 43.9102C114.902 43.6163 114.482 43.2165 114.151 42.7073C113.823 42.1981 113.689 41.5727 113.751 40.8277C113.829 39.8845 114.178 39.1053 114.796 38.4868C115.412 37.8682 116.211 37.4684 117.189 37.2838C117.254 37.2565 117.284 37.2223 117.288 37.1711L117.366 35.8315C117.373 35.7699 117.397 35.7187 117.445 35.6743C117.489 35.6332 117.544 35.6127 117.602 35.6127H119.43C119.489 35.6127 119.54 35.6332 119.577 35.6743C119.618 35.7187 119.636 35.7699 119.629 35.8315L119.495 37.2087C119.492 37.2565 119.519 37.2941 119.577 37.318C120.572 37.5265 121.337 37.9707 121.877 38.6508C122.417 39.3275 122.646 40.1579 122.564 41.1387L122.54 41.4121C122.533 41.4736 122.51 41.5283 122.462 41.5693C122.417 41.6137 122.363 41.6342 122.305 41.6342H120.312C120.251 41.6342 120.199 41.6137 120.162 41.5693C120.121 41.5283 120.104 41.4736 120.111 41.4121L120.124 41.2685C120.169 40.7525 120.005 40.3151 119.632 39.9563C119.26 39.594 118.726 39.4129 118.033 39.4129C117.486 39.4129 117.049 39.5359 116.724 39.782C116.399 40.0246 116.218 40.3629 116.184 40.7901C116.157 41.0977 116.225 41.354 116.386 41.5624C116.543 41.7709 116.792 41.9623 117.131 42.1331C117.469 42.304 118.002 42.5227 118.72 42.7927C119.512 43.1003 120.131 43.3737 120.589 43.6197C121.043 43.8658 121.436 44.2314 121.775 44.7201C122.11 45.2122 122.246 45.841 122.181 46.6134C122.099 47.5941 121.734 48.4007 121.084 49.0363C120.435 49.6754 119.581 50.0786 118.532 50.2495C118.47 50.2734 118.436 50.311 118.433 50.3588L118.354 51.5549C118.347 51.6164 118.32 51.6677 118.275 51.7121C118.228 51.7531 118.176 51.777 118.115 51.777H116.29C116.228 51.777 116.177 51.7531 116.14 51.7121C116.098 51.6677 116.081 51.6164 116.088 51.5549L116.211 50.3417C116.215 50.2939 116.187 50.2563 116.126 50.2324C115.107 50.0239 114.332 49.5967 113.795 48.9474C113.259 48.3016 113.033 47.4848 113.115 46.504L113.149 46.0973C113.153 46.0392 113.18 45.9846 113.228 45.9401C113.272 45.8991 113.327 45.8786 113.385 45.8786H115.36C115.422 45.8786 115.473 45.8991 115.511 45.9401C115.552 45.9846 115.569 46.0392 115.562 46.0973L115.538 46.3707C115.497 46.8628 115.675 47.2763 116.071 47.6112C116.468 47.9461 117.042 48.117 117.783 48.117M119.236 29.417C111.605 29.417 104.9 35.6332 104.257 43.3019C103.615 50.9705 109.277 57.1902 116.908 57.1902C124.539 57.1902 131.244 50.974 131.887 43.3019C132.529 35.6332 126.867 29.417 119.236 29.417Z",
    fill: "#FFC86A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.434 35.6123H117.605C117.547 35.6123 117.493 35.6328 117.448 35.6738C117.4 35.7182 117.377 35.7695 117.37 35.831L117.291 37.1706C117.288 37.2219 117.254 37.2561 117.192 37.2834C116.215 37.468 115.415 37.8678 114.8 38.4863C114.181 39.1049 113.833 39.8841 113.754 40.8273C113.693 41.5723 113.826 42.1976 114.154 42.7068C114.485 43.216 114.906 43.6159 115.415 43.9098C115.924 44.2037 116.567 44.4907 117.332 44.7744C118.005 45.0443 118.494 45.2562 118.805 45.4066C119.113 45.5604 119.352 45.7381 119.519 45.9397C119.683 46.1447 119.755 46.3908 119.731 46.6847C119.697 47.0914 119.519 47.4297 119.198 47.7031C118.873 47.9765 118.405 48.1166 117.783 48.1166C117.038 48.1166 116.467 47.9491 116.071 47.6108C115.675 47.2725 115.497 46.859 115.538 46.3703L115.562 46.0969C115.565 46.0388 115.552 45.9841 115.511 45.9397C115.473 45.8987 115.422 45.8782 115.36 45.8782H113.385C113.327 45.8782 113.272 45.8987 113.228 45.9397C113.18 45.9841 113.156 46.0388 113.149 46.0969L113.115 46.5036C113.033 47.4809 113.259 48.2977 113.795 48.947C114.332 49.5963 115.107 50.0269 116.126 50.2319C116.184 50.2559 116.215 50.2935 116.211 50.3413L116.088 51.5545C116.081 51.616 116.098 51.6673 116.139 51.7117C116.177 51.7527 116.228 51.7766 116.29 51.7766H118.115C118.176 51.7766 118.227 51.7527 118.275 51.7117C118.32 51.6673 118.347 51.616 118.354 51.5545L118.433 50.3584C118.436 50.3105 118.474 50.273 118.532 50.249C119.581 50.0782 120.432 49.6749 121.084 49.0359C121.734 48.4002 122.099 47.5937 122.181 46.6129C122.246 45.8406 122.11 45.2118 121.775 44.7197C121.436 44.231 121.04 43.8653 120.589 43.6193C120.134 43.3732 119.512 43.0998 118.72 42.7923C118.002 42.5223 117.469 42.3036 117.13 42.1327C116.792 41.9618 116.543 41.7705 116.385 41.562C116.225 41.3535 116.16 41.0972 116.184 40.7897C116.221 40.3625 116.403 40.0242 116.724 39.7815C117.052 39.5355 117.486 39.4125 118.033 39.4125C118.726 39.4125 119.26 39.5936 119.632 39.9558C120.005 40.3181 120.169 40.7555 120.124 41.2681L120.11 41.4116C120.104 41.4731 120.121 41.5278 120.162 41.5688C120.199 41.6133 120.251 41.6338 120.312 41.6338H122.304C122.363 41.6338 122.417 41.6133 122.462 41.5688C122.509 41.5278 122.533 41.4731 122.54 41.4116L122.564 41.1382C122.646 40.1609 122.417 39.3304 121.877 38.6504C121.337 37.9703 120.572 37.526 119.577 37.3176C119.519 37.2937 119.492 37.2561 119.495 37.2082L119.629 35.831C119.635 35.7695 119.618 35.7182 119.577 35.6738C119.54 35.6328 119.488 35.6123 119.43 35.6123",
    fill: "#AD8D54"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0228 37.4479V18.5189C13.0228 18.1772 12.746 17.9004 12.4043 17.9004H4.4144C4.07266 17.9004 3.79585 18.1772 3.79585 18.5189V37.4479C3.79585 37.7897 3.51904 38.0665 3.1773 38.0665H0.716773C0.166571 38.0665 -0.110238 38.7329 0.279346 39.119L7.97192 46.8116C8.21455 47.0542 8.60414 47.0542 8.84677 46.8116L16.5393 39.119C16.9289 38.7295 16.6521 38.0665 16.1019 38.0665H13.6414C13.2996 38.0665 13.0228 37.7897 13.0228 37.4479Z",
    fill: "#0D9BAF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M123.62 74.5575V65.0947C123.62 64.9238 123.484 64.7871 123.313 64.7871H119.318C119.147 64.7871 119.01 64.9238 119.01 65.0947V74.5575C119.01 74.7283 118.874 74.865 118.703 74.865H117.473C117.199 74.865 117.059 75.1965 117.254 75.3913L121.098 79.2359C121.218 79.3555 121.413 79.3555 121.536 79.2359L125.38 75.3913C125.575 75.1965 125.438 74.865 125.162 74.865H123.931C123.761 74.865 123.624 74.7283 123.624 74.5575H123.62Z",
    fill: "#0D9BAF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 47,
    width: 15,
    height: 11
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6894 47.8685L80.9912 57.509C80.9126 57.4543 80.8135 57.4304 80.7042 57.4407L66.4023 47.8002C66.5083 47.7899 66.6108 47.8138 66.6894 47.8685Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7076 57.4404L66.4058 47.7999C66.4844 47.7931 66.5595 47.8033 66.6245 47.8307L80.9263 57.4711C80.8614 57.4438 80.7862 57.4301 80.7076 57.4404Z",
    fill: "#BC485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9263 57.4715L66.6245 47.8311C66.6484 47.8413 66.6724 47.855 66.6929 47.8686L80.9947 57.5091C80.9742 57.4955 80.9503 57.4818 80.9263 57.4715Z",
    fill: "#B9475C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 81,
    width: 16,
    height: 11
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3145 91.7381L37.0127 82.0976C36.8965 82.019 36.8247 81.8857 36.8213 81.7285L51.1231 91.369C51.1231 91.5296 51.1983 91.6629 51.3145 91.7381Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3145 91.7381L37.0127 82.0976C36.8965 82.019 36.8247 81.8857 36.8213 81.7285L51.1231 91.369C51.1231 91.5296 51.1983 91.6629 51.3145 91.7381Z",
    fill: "#A84153"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3829 60.5228L37.0776 50.8823L66.4058 47.7998L80.7076 57.4403L51.3829 60.5228Z",
    fill: "#C14A5F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1231 91.3689L36.8213 81.7284L36.6094 51.4229L50.9112 61.0599L51.1231 91.3689Z",
    fill: "#A54052"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7075 57.441C80.9706 57.4137 81.1825 57.6085 81.1859 57.8819L81.3978 88.1874C81.3978 88.4574 81.1893 88.7 80.9262 88.7273L51.6014 91.8098C51.3383 91.8372 51.1264 91.6424 51.123 91.369L50.9111 61.0635C50.9111 60.7935 51.1196 60.5509 51.3827 60.5235L80.7075 57.441Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 50,
    width: 16,
    height: 12
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9112 61.0593L36.6094 51.4189C36.6094 51.1489 36.8178 50.9062 37.081 50.8789L51.3828 60.5194C51.1197 60.5467 50.9112 60.786 50.9112 61.0593Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9112 61.0589L36.6094 51.4184C36.6094 51.3227 36.6367 51.2305 36.6811 51.1484L50.983 60.7889C50.9385 60.8709 50.9112 60.9632 50.9112 61.0589Z",
    fill: "#A84153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.983 60.7884L36.6812 51.1479C36.6948 51.124 36.7119 51.1001 36.729 51.0762L51.0308 60.7167C51.0137 60.7372 50.9966 60.7611 50.983 60.7884Z",
    fill: "#AB4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0308 60.7206L36.729 51.0801C36.7427 51.063 36.7598 51.0425 36.7768 51.0254L51.0787 60.6659C51.0787 60.6659 51.0445 60.7001 51.0308 60.7206Z",
    fill: "#AE4356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0787 60.6654L36.7769 51.0249C36.7769 51.0249 36.811 50.9941 36.8281 50.9805L51.1299 60.621C51.1129 60.6346 51.0958 60.6483 51.0787 60.6654Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.13 60.6244L36.8281 50.9839C36.8452 50.9702 36.8657 50.9565 36.8828 50.9463L51.1846 60.5868C51.1641 60.597 51.147 60.6107 51.13 60.6244Z",
    fill: "#B34559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1846 60.5873L36.8828 50.9468C36.9033 50.9331 36.9272 50.9229 36.9477 50.916L51.2496 60.5565C51.2256 60.5668 51.2051 60.577 51.1846 60.5873Z",
    fill: "#B6465A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2496 60.5526L36.9478 50.9121C36.9751 50.9019 37.0058 50.8916 37.0366 50.8848L51.3384 60.5253C51.3077 60.5321 51.2769 60.5389 51.2496 60.5526Z",
    fill: "#B9475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3384 60.5292L37.0366 50.8887C37.0366 50.8887 37.064 50.8853 37.0776 50.8818L51.3795 60.5223C51.3795 60.5223 51.3521 60.5257 51.3384 60.5292Z",
    fill: "#BC485D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 73,
    width: 11,
    height: 16
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8696 82.4868L39.7261 73.3691L49.5682 79.5205L49.7117 88.6347L39.8696 82.4868Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1767 85.3916L45.0468 77.1078L49.3459 79.7939L49.4758 88.0777L45.1767 85.3916ZM49.5681 79.5205L49.4553 79.4487L44.9238 76.6157L44.811 76.5439V76.7558L44.9511 85.4497V85.6582L45.0673 85.7299L49.5988 88.5629L49.7116 88.6347V88.4263L49.5715 79.7324V79.5205",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2102 79.124H47.2033L47.1726 79.1582L47.1657 79.8383L47.1965 79.8553C46.8582 79.6503 46.4207 79.4213 46.0687 79.5649C45.9765 79.599 45.8979 79.664 45.8193 79.7494C45.7441 79.8348 45.6757 79.9374 45.6211 80.0672C45.5664 80.1937 45.522 80.3406 45.4946 80.5081C45.481 80.5969 45.4707 80.6824 45.4639 80.7746C45.457 80.8703 45.457 81.0138 45.457 81.1164C45.6655 81.0959 45.7885 81.0924 45.9081 81.1676C46.0277 81.2428 46.1473 81.3932 46.3558 81.6768C46.5472 81.6324 46.677 81.6324 46.8035 81.711C46.9163 81.7828 47.0325 81.9195 47.1897 82.1416L47.1965 82.5517L47.2307 82.5722L47.2785 85.5385C47.2819 85.8119 47.4118 86.116 47.5587 86.2083C47.7057 86.3006 47.8287 86.1536 47.8253 85.8802L47.8185 85.3745L47.7809 85.2856L47.7467 85.33L47.7535 85.8358C47.7535 86.0374 47.6681 86.1434 47.5587 86.075C47.4494 86.0067 47.3537 85.788 47.3537 85.5863L47.3058 82.62L47.3366 82.6405L47.3298 82.2304C47.4938 82.2031 47.6134 82.2065 47.733 82.2817C47.8595 82.3603 47.9859 82.5209 48.1636 82.8046C48.3345 82.7431 48.4643 82.7396 48.601 82.8251C48.7377 82.9105 48.8778 83.0814 49.0658 83.365C49.0556 82.726 48.8403 81.8374 48.5122 81.2121C48.1841 80.6003 47.7399 80.1903 47.2512 79.8793L47.2819 79.8998L47.2512 79.1958L47.2204 79.1172",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0917 82.2168L39.9619 73.933L44.261 76.6191L44.3908 84.9029L40.0917 82.2168ZM44.4865 76.3423L44.3703 76.2705L39.8423 73.4409L39.7261 73.3691V73.581L39.8662 82.2749V82.4833L39.9858 82.5551L44.5139 85.3847L44.63 85.4565V85.248L44.4899 76.5542V76.3423",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8203 83.1017L40.6216 81.1025L40.6318 81.909L43.8305 83.9082L43.8203 83.1017Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4145 76.0107L40.9258 77.2034L41.1821 77.3606L41.2402 81.0412L41.7528 81.3624L41.6947 77.6819L41.951 77.8425L41.4145 76.0107Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8495 76.9092L42.3608 78.0984L42.6171 78.2591L42.6752 81.9362L43.1879 82.2574L43.1298 78.5803L43.3861 78.7375L42.8495 76.9092Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 77,
    width: 10,
    height: 11
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5034 87.7732L70.4351 78.2625L79.1528 77.3467L79.2178 86.8573L70.5034 87.7732Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5516 79.9646C73.2474 79.9954 72.9467 80.1663 72.7997 80.4533L72.2939 81.417L73.7839 82.1484L74.7101 80.3713L74.0402 80.0432C73.8933 79.9715 73.7224 79.9441 73.5516 79.9646Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3801 79.5273C74.8641 79.582 74.2455 79.7085 73.8047 79.7768C74.3446 79.9374 74.6009 80.0741 74.7684 80.1903C75.1648 80.4705 75.1272 80.6243 75.3664 81.1574C75.1443 81.3112 74.9188 81.465 74.6966 81.6222C75.281 81.5914 75.862 81.5641 76.4463 81.5334C76.7539 80.9763 77.0683 80.409 77.3793 79.852C77.1503 79.9716 76.9248 80.098 76.6992 80.2177C76.6548 80.1527 76.6172 80.0878 76.5796 80.0194C76.5352 79.9545 76.4908 79.8896 76.4498 79.8281C76.2276 79.5683 76.0499 79.5 75.838 79.5C75.7013 79.5 75.5441 79.5103 75.3767 79.5273",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9169 87.2982L70.8554 78.6521L78.7325 77.8251L78.794 86.4711L70.9169 87.2982ZM79.1528 77.3467L78.941 77.3672L70.6469 78.2386L70.4351 78.2591V78.4744L70.5 87.5545V87.7697L70.7119 87.7492L79.0059 86.8778L79.2178 86.8573V86.642L79.1528 77.562V77.3467Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3176 81.1123L75.8652 82.1922L76.8563 83.7369L77.509 83.2516C77.9088 82.9577 78.107 82.3357 77.8542 81.953L77.3142 81.1123",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8001 83.2285C75.4994 83.7753 75.1987 84.3221 74.8979 84.8654C75.2021 85.3712 75.5028 85.877 75.8001 86.3828C75.8275 86.1265 75.8514 85.8736 75.8719 85.6138C75.9505 85.607 76.0325 85.5933 76.1077 85.5831C76.1863 85.566 76.2649 85.5523 76.3401 85.5421C76.6853 85.4396 76.8459 85.3063 76.9689 85.1081C77.2867 84.5955 77.6216 83.7001 77.8745 83.1328C77.4337 83.5634 77.1739 83.7479 76.9826 83.8505C76.7741 83.9632 76.6374 84.0077 76.4973 84.0248C76.323 84.0418 76.1453 84.0179 75.8241 84.0248C75.8138 83.7582 75.807 83.4916 75.8001 83.2285Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7554 84.2563L72.7622 85.056C72.7622 85.5413 73.1552 85.9889 73.6234 85.9411L74.6384 85.8386L74.6315 84.0684L72.7588 84.2563",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2109 82.1484C71.4057 82.2817 71.6005 82.4184 71.7987 82.5517C71.7577 82.6269 71.7201 82.6986 71.6825 82.7738C71.6484 82.8524 71.6108 82.9242 71.58 83.0028C71.4502 83.3513 71.4638 83.553 71.5561 83.7478C71.7851 84.257 72.3182 84.9473 72.6326 85.4257C72.5437 84.8447 72.5506 84.5338 72.5779 84.315C72.6497 83.7922 72.7966 83.7307 73.1452 83.2112C73.3673 83.324 73.5894 83.4299 73.8116 83.5461C73.545 83.0335 73.2751 82.5243 73.0085 82.0186C72.407 82.0596 71.8124 82.1006 71.2109 82.145",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 48,
    width: 19,
    height: 12
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6695 59.1013L50.4976 49.4233L54.824 48.9688L68.996 58.6468L64.6695 59.1013Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.824 48.9688L50.4976 49.4233L64.6695 59.1013L68.996 58.6468L54.824 48.9688Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 58,
    width: 6,
    height: 6
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7104 63.4523L64.6797 59.0815L69.0061 58.627L69.0369 62.9978L64.7104 63.4523Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0061 58.627L64.6797 59.0815L64.7104 63.4523L69.0369 62.9978L69.0061 58.627Z",
    fill: "#843D47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5048 47.8417L37.2655 50.8182C37.1527 50.8285 37.1185 50.9754 37.2108 51.0369L51.2051 60.4656C51.229 60.4826 51.2563 60.4895 51.2837 60.4861L80.523 57.5095C80.6357 57.4992 80.6699 57.3523 80.5776 57.2908L66.5834 47.8622C66.5595 47.8451 66.5321 47.8383 66.5048 47.8417Z",
    fill: "#192227"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 16,
    width: 15,
    height: 10
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6894 16.2093L80.9912 25.8498C80.9126 25.7951 80.8135 25.7712 80.7042 25.7815L66.4023 16.141C66.5083 16.1307 66.6108 16.1547 66.6894 16.2093Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7076 25.7812L66.4058 16.1407C66.4844 16.1339 66.5595 16.1441 66.6245 16.1715L80.9263 25.812C80.8614 25.7846 80.7862 25.771 80.7076 25.7812Z",
    fill: "#BC485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9263 25.8124L66.6245 16.1719C66.6484 16.1821 66.6724 16.1958 66.6929 16.2095L80.9947 25.85C80.9742 25.8363 80.9503 25.8226 80.9263 25.8124Z",
    fill: "#B9475C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 50,
    width: 16,
    height: 11
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3145 60.0789L37.0127 50.4384C36.8965 50.3598 36.8247 50.2265 36.8213 50.0693L51.1231 59.7098C51.1231 59.8704 51.1983 60.0037 51.3145 60.0789Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3145 60.0789L37.0127 50.4384C36.8965 50.3598 36.8247 50.2265 36.8213 50.0693L51.1231 59.7098C51.1231 59.8704 51.1983 60.0037 51.3145 60.0789Z",
    fill: "#A84153"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3829 28.8636L37.0776 19.2231L66.4058 16.1406L80.7076 25.7811L51.3829 28.8636Z",
    fill: "#C14A5F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1231 59.7097L36.8213 50.0692L36.6094 19.7637L50.9112 29.4007L51.1231 59.7097Z",
    fill: "#A54052"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7075 25.7819C80.9706 25.7545 81.1825 25.9493 81.1859 26.2227L81.3978 56.5282C81.3978 56.7982 81.1893 57.0408 80.9262 57.0682L51.6014 60.1507C51.3383 60.178 51.1264 59.9832 51.123 59.7098L50.9111 29.4043C50.9111 29.1343 51.1196 28.8917 51.3827 28.8644L80.7075 25.7819Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 19,
    width: 16,
    height: 11
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9112 29.4002L36.6094 19.7597C36.6094 19.4897 36.8178 19.2471 37.081 19.2197L51.3828 28.8602C51.1197 28.8876 50.9112 29.1268 50.9112 29.4002Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9112 29.3997L36.6094 19.7592C36.6094 19.6635 36.6367 19.5713 36.6811 19.4893L50.983 29.1297C50.9385 29.2118 50.9112 29.304 50.9112 29.3997Z",
    fill: "#A84153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.983 29.1302L36.6812 19.4897C36.6948 19.4658 36.7119 19.4419 36.729 19.418L51.0308 29.0585C51.0137 29.079 50.9966 29.1029 50.983 29.1302Z",
    fill: "#AB4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0308 29.0614L36.729 19.4209C36.7427 19.4038 36.7598 19.3833 36.7768 19.3662L51.0787 29.0067C51.0787 29.0067 51.0445 29.0409 51.0308 29.0614Z",
    fill: "#AE4356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0787 29.0072L36.7769 19.3667C36.7769 19.3667 36.811 19.3359 36.8281 19.3223L51.1299 28.9628C51.1129 28.9764 51.0958 28.9901 51.0787 29.0072Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.13 28.9623L36.8281 19.3218C36.8452 19.3081 36.8657 19.2944 36.8828 19.2842L51.1846 28.9247C51.1641 28.9349 51.147 28.9486 51.13 28.9623Z",
    fill: "#B34559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1846 28.9281L36.8828 19.2876C36.9033 19.2739 36.9272 19.2637 36.9477 19.2568L51.2496 28.8973C51.2256 28.9076 51.2051 28.9178 51.1846 28.9281Z",
    fill: "#B6465A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2496 28.8944L36.9478 19.2539C36.9751 19.2437 37.0058 19.2334 37.0366 19.2266L51.3384 28.8671C51.3077 28.8739 51.2769 28.8807 51.2496 28.8944Z",
    fill: "#B9475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3384 28.8671L37.0366 19.2266C37.0366 19.2266 37.064 19.2231 37.0776 19.2197L51.3795 28.8602C51.3795 28.8602 51.3521 28.8636 51.3384 28.8671Z",
    fill: "#BC485D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 41,
    width: 11,
    height: 16
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8696 50.8242L39.7261 41.71L49.5682 47.8613L49.7117 56.9755L39.8696 50.8242Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1767 53.7324L45.0468 45.4486L49.3459 48.1347L49.4758 56.4185L45.1767 53.7324ZM49.5681 47.8613L49.4553 47.7896L44.9238 44.9565L44.811 44.8848V45.0966L44.9511 53.7905V53.999L45.0673 54.0707L49.5988 56.9038L49.7116 56.9755V56.7671L49.5715 48.0732V47.8613",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2102 47.4648H47.2033L47.1726 47.499L47.1657 48.1791L47.1965 48.1962C46.8582 47.9911 46.4207 47.7622 46.0687 47.9057C45.9765 47.9399 45.8979 48.0048 45.8193 48.0902C45.7441 48.1757 45.6757 48.2782 45.6211 48.408C45.5664 48.5345 45.522 48.6814 45.4946 48.8489C45.481 48.9377 45.4707 49.0232 45.4639 49.1154C45.457 49.2111 45.457 49.3547 45.457 49.4572C45.6655 49.4367 45.7885 49.4333 45.9081 49.5084C46.0277 49.5836 46.1473 49.734 46.3558 50.0176C46.5472 49.9732 46.677 49.9732 46.8035 50.0518C46.9163 50.1236 47.0325 50.2603 47.1897 50.4824L47.1965 50.8925L47.2307 50.913L47.2785 53.8793C47.2819 54.1527 47.4118 54.4568 47.5587 54.5491C47.7057 54.6414 47.8287 54.4944 47.8253 54.221L47.8185 53.7153L47.7809 53.6264L47.7467 53.6708L47.7535 54.1766C47.7535 54.3782 47.6681 54.4842 47.5587 54.4158C47.4494 54.3475 47.3537 54.1288 47.3537 53.9272L47.3058 50.9608L47.3366 50.9813L47.3298 50.5713C47.4938 50.5439 47.6134 50.5473 47.733 50.6225C47.8595 50.7011 47.9859 50.8617 48.1636 51.1454C48.3345 51.0839 48.4643 51.0805 48.601 51.1659C48.7377 51.2513 48.8778 51.4222 49.0658 51.7058C49.0556 51.0668 48.8403 50.1783 48.5122 49.5529C48.1841 48.9412 47.7399 48.5311 47.2512 48.2201L47.2819 48.2406L47.2512 47.5366L47.2204 47.458",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0917 50.5542L39.9619 42.2704L44.261 44.9565L44.3908 53.2403L40.0917 50.5542ZM44.4865 44.6831L44.3703 44.6113L39.8423 41.7817L39.7261 41.71V41.9218L39.8662 50.6157V50.8242L39.9858 50.8959L44.5139 53.7255L44.63 53.7973V53.5888L44.4899 44.895V44.6831",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8203 51.4425L40.6216 49.4434L40.6318 50.2499L43.8305 52.249L43.8203 51.4425Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4145 44.3516L40.9258 45.5408L41.1821 45.7014L41.2402 49.382L41.7528 49.7032L41.6947 46.0227L41.951 46.1833L41.4145 44.3516Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8495 45.25L42.3608 46.4393L42.6171 46.5999L42.6752 50.277L43.1879 50.5982L43.1298 46.9211L43.3861 47.0783L42.8495 45.25Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 45,
    width: 10,
    height: 12
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5029 56.114L70.4346 46.6034L79.1524 45.6875L79.2173 55.1981L70.5029 56.114Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5511 48.3055C73.2469 48.3362 72.9462 48.5071 72.7992 48.7941L72.2935 49.7578L73.7834 50.4892L74.7096 48.7121L74.0397 48.3841C73.8928 48.3123 73.7219 48.2849 73.5511 48.3055Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3796 47.8682C74.8636 47.9228 74.245 48.0493 73.8042 48.1176C74.3441 48.2782 74.6005 48.4149 74.7679 48.5311C75.1643 48.8114 75.1267 48.9651 75.366 49.4983C75.1438 49.652 74.9183 49.8058 74.6961 49.963C75.2805 49.9323 75.8615 49.9049 76.4459 49.8742C76.7534 49.3171 77.0678 48.7498 77.3788 48.1928C77.1498 48.3124 76.9243 48.4389 76.6987 48.5585C76.6543 48.4935 76.6167 48.4286 76.5791 48.3603C76.5347 48.2953 76.4903 48.2304 76.4493 48.1689C76.2271 47.9092 76.0494 47.8408 75.8376 47.8408C75.7009 47.8408 75.5437 47.8511 75.3762 47.8682",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9164 55.639L70.8549 46.9929L78.732 46.1659L78.7935 54.812L70.9164 55.639ZM79.1524 45.6875L78.9405 45.708L70.6464 46.5794L70.4346 46.5999V46.8152L70.4995 55.8953V56.1106L70.7114 56.0901L79.0054 55.2186L79.2173 55.1981V54.9828L79.1524 45.9028V45.6875Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3171 49.4531L75.8647 50.533L76.8558 52.0777L77.5085 51.5924C77.9084 51.2985 78.1066 50.6766 77.8537 50.2938L77.3137 49.4531",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7997 51.5693C75.4989 52.1161 75.1982 52.6629 74.8975 53.2063C75.2016 53.712 75.5023 54.2178 75.7997 54.7236C75.827 54.4673 75.8509 54.2144 75.8714 53.9547C75.95 53.9478 76.032 53.9342 76.1072 53.9239C76.1858 53.9068 76.2644 53.8932 76.3396 53.8829C76.6848 53.7804 76.8454 53.6471 76.9684 53.4489C77.2862 52.9363 77.6211 52.0409 77.874 51.4736C77.4332 51.9042 77.1734 52.0888 76.9821 52.1913C76.7736 52.3041 76.6369 52.3485 76.4968 52.3656C76.3225 52.3827 76.1448 52.3587 75.8236 52.3656C75.8133 52.099 75.8065 51.8325 75.7997 51.5693Z",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7549 52.5971L72.7617 53.3968C72.7617 53.8821 73.1547 54.3298 73.6229 54.2819L74.6379 54.1794L74.631 52.4092L72.7583 52.5971",
    fill: "#6E333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2104 50.4892C71.4052 50.6225 71.6 50.7592 71.7982 50.8925C71.7572 50.9677 71.7196 51.0394 71.6821 51.1146C71.6479 51.1932 71.6103 51.265 71.5795 51.3436C71.4497 51.6922 71.4633 51.8938 71.5556 52.0886C71.7846 52.5978 72.3177 53.2881 72.6321 53.7665C72.5432 53.1856 72.5501 52.8746 72.5774 52.6559C72.6492 52.133 72.7961 52.0715 73.1447 51.552C73.3668 51.6648 73.589 51.7708 73.8111 51.887C73.5445 51.3743 73.2746 50.8652 73.008 50.3594C72.4065 50.4004 71.8119 50.4414 71.2104 50.4858",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 17,
    width: 19,
    height: 11
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6695 27.4422L50.4976 17.7641L54.824 17.3096L68.996 26.9877L64.6695 27.4422Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.824 17.3096L50.4976 17.7641L64.6695 27.4422L68.996 26.9877L54.824 17.3096Z",
    fill: "#6E333C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_3066_57689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 26,
    width: 6,
    height: 6
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7104 31.7931L64.6797 27.4223L69.0061 26.9678L69.0369 31.3386L64.7104 31.7931Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_3066_57689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0061 26.9678L64.6797 27.4223L64.7104 31.7931L69.0369 31.3386L69.0061 26.9678Z",
    fill: "#843D47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3066_57689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.803,
    height: 100,
    fill: "white",
    transform: "translate(0.0981445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadora);
export default __webpack_public_path__ + "static/media/calculadora.a6be6ebc61070a50ec8d1f8ec52ba914.svg";
export { ForwardRef as ReactComponent };